import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Injectable, Inject, Optional, HostBinding, Directive, Pipe, Self, ContentChild, TemplateRef, forwardRef, ViewChild, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i2$2 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbDatepickerI18nDefault, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ngx-translate/core';
import { TranslatePipe, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import * as i1$3 from '@angular/common/http';
import { HttpResponse, HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BehaviorSubject, Subject, tap, catchError, throwError } from 'rxjs';
import * as i1$1 from '@angular/router';
import { RoutesRecognized, NavigationStart, NavigationEnd, RouterModule, ROUTES, PreloadingStrategy, NoPreloading } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import isEqual from 'lodash.isequal';
import * as i1$4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormGroup, FormControl, Validators, NG_VALIDATORS, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i2$1 from 'ngx-mask';
import { MaskApplierService, NgxMaskModule, NEW_CONFIG, initialConfig } from 'ngx-mask';

class NextButtonComponent {
    constructor() {
        this.disabled = false;
        this.text = 'navigation.next';
        this.dataTestId = 'next-button';
        this.class = '';
        this.clickAction = new EventEmitter();
    }
    click() {
        this.clickAction.emit();
    }
}
NextButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NextButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NextButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: NextButtonComponent, selector: "scu-next-button", inputs: { disabled: "disabled", text: "text", dataTestId: "dataTestId", class: "class" }, outputs: { clickAction: "clickAction" }, ngImport: i0, template: "<button type=\"button\"\n        id=\"next\"\n        class=\"btn text-16 filled-button\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [ngClass]=\"class\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n", styles: [":host .btn.filled-button{min-width:120px;border-width:2px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NextButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-next-button', template: "<button type=\"button\"\n        id=\"next\"\n        class=\"btn text-16 filled-button\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [ngClass]=\"class\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n", styles: [":host .btn.filled-button{min-width:120px;border-width:2px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { disabled: [{
                type: Input
            }], text: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], class: [{
                type: Input
            }], clickAction: [{
                type: Output
            }] } });

class PreviousButtonComponent {
    constructor() {
        this.disabled = false;
        this.text = 'navigation.back';
        this.dataTestId = 'back-button';
        this.class = '';
        this.clickAction = new EventEmitter();
    }
    click() {
        this.clickAction.emit();
    }
}
PreviousButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PreviousButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PreviousButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PreviousButtonComponent, selector: "scu-previous-button", inputs: { disabled: "disabled", text: "text", dataTestId: "dataTestId", class: "class" }, outputs: { clickAction: "clickAction" }, ngImport: i0, template: "<button type=\"button\"\n        id=\"back\"\n        class=\"btn text-16 back-button\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [ngClass]=\"class\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PreviousButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-previous-button', template: "<button type=\"button\"\n        id=\"back\"\n        class=\"btn text-16 back-button\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [ngClass]=\"class\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { disabled: [{
                type: Input
            }], text: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], class: [{
                type: Input
            }], clickAction: [{
                type: Output
            }] } });

class RouterEventsService {
    constructor(router, routerDataKey) {
        this.router = router;
        this.routerDataKey = routerDataKey;
        this.navItemSource = new BehaviorSubject(0);
        const dataKey = routerDataKey ?? 'depth';
        this.subscription = this.router.events.subscribe((data) => {
            if (data instanceof RoutesRecognized) {
                let value = data?.state?.root?.firstChild?.data[dataKey];
                value = value === undefined || value === null ? 0 : value;
                this.navItemSource.next(value);
            }
        });
    }
}
RouterEventsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RouterEventsService, deps: [{ token: i1$1.Router }, { token: 'routerDataKey', optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
RouterEventsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RouterEventsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RouterEventsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['routerDataKey']
                }, {
                    type: Optional
                }] }]; } });

class ProgressBarComponent {
    constructor(routerEventsService) {
        this.routerEventsService = routerEventsService;
        this.height = 'default';
        this.progressValue = this.routerEventsService.navItemSource;
    }
}
ProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ProgressBarComponent, deps: [{ token: RouterEventsService }], target: i0.ɵɵFactoryTarget.Component });
ProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ProgressBarComponent, selector: "scu-progress-bar", inputs: { height: "height" }, ngImport: i0, template: "<ngb-progressbar class=\"sos-style\" type=\"info\" [value]=\"(progressValue | async) ?? 0\" [height]=\"height\"></ngb-progressbar>\n", dependencies: [{ kind: "component", type: i1$2.NgbProgressbar, selector: "ngb-progressbar", inputs: ["max", "animated", "ariaLabel", "striped", "showValue", "textType", "type", "value", "height"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-progress-bar', template: "<ngb-progressbar class=\"sos-style\" type=\"info\" [value]=\"(progressValue | async) ?? 0\" [height]=\"height\"></ngb-progressbar>\n" }]
        }], ctorParameters: function () { return [{ type: RouterEventsService }]; }, propDecorators: { height: [{
                type: Input
            }] } });

class SosLogoComponent {
    constructor() {
        this.poweredByText = '';
        this.imageSource = '';
        this.dataTestId = 'sos-logo';
        this.clickAction = new EventEmitter();
    }
    click() {
        this.clickAction.emit();
    }
}
SosLogoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SosLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SosLogoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SosLogoComponent, selector: "scu-sos-logo", inputs: { poweredByText: "poweredByText", imageSource: "imageSource", dataTestId: "dataTestId" }, outputs: { clickAction: "clickAction" }, ngImport: i0, template: "<a class=\"d-flex flex-column\" (click)=\"click()\" [attr.data-test]=\"dataTestId\">\n  <span class=\"text-10\" *ngIf=\"poweredByText\">{{poweredByText}}</span>\n  <img [src]=\"imageSource\" class=\"sos-logo\" alt=\"SOS International logo\">\n</a>\n", styles: [":host a{text-decoration:none}:host span{color:rgb(var(--scu-backdrop-dark));padding-bottom:5px}.sos-logo{height:35px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SosLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-sos-logo', template: "<a class=\"d-flex flex-column\" (click)=\"click()\" [attr.data-test]=\"dataTestId\">\n  <span class=\"text-10\" *ngIf=\"poweredByText\">{{poweredByText}}</span>\n  <img [src]=\"imageSource\" class=\"sos-logo\" alt=\"SOS International logo\">\n</a>\n", styles: [":host a{text-decoration:none}:host span{color:rgb(var(--scu-backdrop-dark));padding-bottom:5px}.sos-logo{height:35px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { poweredByText: [{
                type: Input
            }], imageSource: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], clickAction: [{
                type: Output
            }] } });

class TitleHeaderComponent {
    constructor() {
        this.dataTestId = 'title-header';
        this.class = '';
    }
}
TitleHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TitleHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TitleHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TitleHeaderComponent, selector: "scu-title-header", inputs: { dataTestId: "dataTestId", class: "class" }, ngImport: i0, template: "<div [ngClass]=\"class\">\n  <h1 [attr.data-test]=\"dataTestId\">\n    <ng-content></ng-content>\n  </h1>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TitleHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-title-header', template: "<div [ngClass]=\"class\">\n  <h1 [attr.data-test]=\"dataTestId\">\n    <ng-content></ng-content>\n  </h1>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { dataTestId: [{
                type: Input
            }], class: [{
                type: Input
            }] } });

class FooterService {
    constructor(router) {
        this.router = router;
        this.modeSubject = new BehaviorSubject(undefined);
        this.isUnderNavigation = false;
        this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event) => {
            this.isUnderNavigation = true;
        });
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            this.isUnderNavigation = false;
            this.modeSubject.next(undefined);
        });
    }
    getModeSubject() {
        return this.modeSubject;
    }
    isEntryMode(mode) {
        const castMode = mode;
        return this.isDefinedBy(castMode, ['navLinkEntry', 'enableNavEntry', 'onNextEntryFn']);
    }
    isNavigationMode(mode) {
        const castMode = mode;
        return this.isDefinedBy(castMode, ['navLinkForward', 'navLinkBackward', 'enableNavForward', 'enableNavBackward', 'onNextFunction']);
    }
    isSubmissionMode(mode) {
        const castMode = mode;
        return this.isDefinedBy(castMode, ['enableNavBackward', 'navLinkBackward', 'submitFunction', 'enableSubmit']);
    }
    setEntryMode(newMode) {
        this.setMode(newMode, this.isEntryMode);
    }
    setNavigationMode(newMode) {
        this.setMode(newMode, this.isNavigationMode);
    }
    setSubmissionMode(newMode) {
        this.setMode(newMode, this.isSubmissionMode);
    }
    setMode(mode, typeGuard) {
        if (this.isUnderNavigation) {
            console.warn("setMode called while under navigation. Call the set*Mode functions from the onInit function and not the constructor");
        }
        const currentValue = this.modeSubject.value;
        if (currentValue === undefined || !typeGuard(currentValue)) {
            this.modeSubject.next(mode);
        }
        else {
            this.overWriteProperties(mode, currentValue);
            this.modeSubject.next(currentValue);
        }
    }
    overWriteProperties(from, to) {
        for (const key of Object.keys(from)) {
            // @ts-ignore
            const value = from[key];
            if (value !== undefined) {
                if (value === null) {
                    // @ts-ignore
                    to[key] = undefined;
                }
                else {
                    // @ts-ignore
                    to[key] = value;
                }
            }
        }
    }
    isDefinedBy(object, keys) {
        if (object === undefined) {
            return false;
        }
        let keyFound = false;
        for (const key of Object.keys(object)) {
            const castKey = key;
            if (!keys.includes(castKey)) {
                return false;
            }
            else {
                keyFound = true;
            }
        }
        return keyFound;
    }
}
FooterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FooterService, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
FooterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FooterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FooterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }]; } });

class FooterComponent {
    constructor(footerService, router, location) {
        this.footerService = footerService;
        this.router = router;
        this.location = location;
        this.imageSource = '';
        this.modeSubscription = footerService.getModeSubject().subscribe(newMode => {
            this.currentMode = newMode;
        });
    }
    get toggleLightBg() {
        return this.isEntryMode(this.currentMode) || this.isSubmissionMode(this.currentMode);
    }
    get toggleBg() {
        return !(this.isEntryMode(this.currentMode) || this.isSubmissionMode(this.currentMode));
    }
    isEntryMode(mode) {
        return this.footerService.isEntryMode(mode);
    }
    isNavigationMode(mode) {
        return this.footerService.isNavigationMode(mode);
    }
    isSubmissionMode(mode) {
        return this.footerService.isSubmissionMode(mode);
    }
    getValue(valueOrFunction, or) {
        if (valueOrFunction === null || valueOrFunction === undefined) {
            return or;
        }
        if (valueOrFunction instanceof Function) {
            const result = valueOrFunction();
            return result;
        }
        else {
            return valueOrFunction;
        }
    }
    submitNavitation(mode, route) {
        if (mode.onNextFunction) {
            mode.onNextFunction();
        }
        const getRoute = this.getValue(route);
        this.nextButtonClicked(getRoute);
    }
    submitSubmission(mode) {
        if (mode.submitFunction) {
            mode.submitFunction();
        }
    }
    nextButtonClicked(route, onNextFn) {
        if (onNextFn) {
            onNextFn();
        }
        this.router.navigate([route]);
    }
    previousButtonClicked(route) {
        if (route) {
            this.router.navigate([route]);
        }
        else {
            this.location.back();
        }
    }
}
FooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FooterComponent, deps: [{ token: FooterService }, { token: i1$1.Router }, { token: i1.Location }], target: i0.ɵɵFactoryTarget.Component });
FooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: FooterComponent, selector: "scu-footer", inputs: { imageSource: "imageSource" }, host: { properties: { "class.scu-backdrop-light-bg": "this.toggleLightBg", "class.scu-backdrop-bg": "this.toggleBg" } }, ngImport: i0, template: "<div class=\"element-outlet\">\n  <ng-container *ngIf=\"isEntryMode(currentMode)\">\n    <div class=\"d-flex justify-content-between\">\n      <scu-sos-logo [poweredByText]=\"'general.powered-by' | translate\" [imageSource]=\"imageSource\"\n                    class=\"my-auto py-4\"></scu-sos-logo>\n      <scu-next-button (clickAction)=\"nextButtonClicked(this.getValue(currentMode.navLinkEntry), currentMode.onNextEntryFn)\" [disabled]=\"!this.getValue(currentMode.enableNavEntry, true)\"\n                       text=\"{{ 'navigation.start' | translate }}\" class=\"my-auto\">\n      </scu-next-button>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"isNavigationMode(currentMode)\">\n    <div class=\"d-flex justify-content-between pt-2 pb-4\">\n      <scu-previous-button\n        (clickAction)=\"this.previousButtonClicked(this.getValue(currentMode.navLinkBackward))\">\n      </scu-previous-button>\n      <scu-next-button [disabled]=\"!this.getValue(currentMode.enableNavForward, true)\"\n                       (clickAction)=\"this.submitNavitation(currentMode, currentMode.navLinkForward)\">\n      </scu-next-button>\n    </div>\n    <div class=\"align-self-start ps-4\">\n      <span class=\"text-10\">{{'general.powered-by'| translate}} {{'general.sos-footer-brand' | translate}}</span>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"isSubmissionMode(currentMode)\">\n    <div class=\"d-flex justify-content-between py-4\">\n      <scu-previous-button [disabled]=\"!this.getValue(currentMode.enableNavBackward, false) ?? false\"\n        (clickAction)=\"this.previousButtonClicked(this.getValue(currentMode.navLinkBackward))\">\n      </scu-previous-button>\n      <scu-next-button [disabled]=\"!this.getValue(currentMode.enableSubmit, false)\"\n                       (clickAction)=\"this.submitSubmission(currentMode)\"\n                       text=\"{{ 'navigation.senddata' | translate }}\"></scu-next-button>\n    </div>\n    <div class=\"scu-backdrop-light-bg pb-4\">\n      <scu-sos-logo [poweredByText]=\"'general.powered-by' | translate\" [imageSource]=\"imageSource\"></scu-sos-logo>\n    </div>\n\n\n  </ng-container>\n</div>\n\n\n\n<div class=\"brand\"></div>\n", styles: [":host .brand{height:8px;background-color:rgba(var(--scu-sos-red),var(--bs-bg-opacity, 1))}:host.scu-backdrop-bg{background-color:rgb(var(--scu-backdrop))}:host.scu-backdrop-light-bg{background-color:rgb(var(--scu-backdrop-light))}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NextButtonComponent, selector: "scu-next-button", inputs: ["disabled", "text", "dataTestId", "class"], outputs: ["clickAction"] }, { kind: "component", type: PreviousButtonComponent, selector: "scu-previous-button", inputs: ["disabled", "text", "dataTestId", "class"], outputs: ["clickAction"] }, { kind: "component", type: SosLogoComponent, selector: "scu-sos-logo", inputs: ["poweredByText", "imageSource", "dataTestId"], outputs: ["clickAction"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-footer', template: "<div class=\"element-outlet\">\n  <ng-container *ngIf=\"isEntryMode(currentMode)\">\n    <div class=\"d-flex justify-content-between\">\n      <scu-sos-logo [poweredByText]=\"'general.powered-by' | translate\" [imageSource]=\"imageSource\"\n                    class=\"my-auto py-4\"></scu-sos-logo>\n      <scu-next-button (clickAction)=\"nextButtonClicked(this.getValue(currentMode.navLinkEntry), currentMode.onNextEntryFn)\" [disabled]=\"!this.getValue(currentMode.enableNavEntry, true)\"\n                       text=\"{{ 'navigation.start' | translate }}\" class=\"my-auto\">\n      </scu-next-button>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"isNavigationMode(currentMode)\">\n    <div class=\"d-flex justify-content-between pt-2 pb-4\">\n      <scu-previous-button\n        (clickAction)=\"this.previousButtonClicked(this.getValue(currentMode.navLinkBackward))\">\n      </scu-previous-button>\n      <scu-next-button [disabled]=\"!this.getValue(currentMode.enableNavForward, true)\"\n                       (clickAction)=\"this.submitNavitation(currentMode, currentMode.navLinkForward)\">\n      </scu-next-button>\n    </div>\n    <div class=\"align-self-start ps-4\">\n      <span class=\"text-10\">{{'general.powered-by'| translate}} {{'general.sos-footer-brand' | translate}}</span>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"isSubmissionMode(currentMode)\">\n    <div class=\"d-flex justify-content-between py-4\">\n      <scu-previous-button [disabled]=\"!this.getValue(currentMode.enableNavBackward, false) ?? false\"\n        (clickAction)=\"this.previousButtonClicked(this.getValue(currentMode.navLinkBackward))\">\n      </scu-previous-button>\n      <scu-next-button [disabled]=\"!this.getValue(currentMode.enableSubmit, false)\"\n                       (clickAction)=\"this.submitSubmission(currentMode)\"\n                       text=\"{{ 'navigation.senddata' | translate }}\"></scu-next-button>\n    </div>\n    <div class=\"scu-backdrop-light-bg pb-4\">\n      <scu-sos-logo [poweredByText]=\"'general.powered-by' | translate\" [imageSource]=\"imageSource\"></scu-sos-logo>\n    </div>\n\n\n  </ng-container>\n</div>\n\n\n\n<div class=\"brand\"></div>\n", styles: [":host .brand{height:8px;background-color:rgba(var(--scu-sos-red),var(--bs-bg-opacity, 1))}:host.scu-backdrop-bg{background-color:rgb(var(--scu-backdrop))}:host.scu-backdrop-light-bg{background-color:rgb(var(--scu-backdrop-light))}\n"] }]
        }], ctorParameters: function () { return [{ type: FooterService }, { type: i1$1.Router }, { type: i1.Location }]; }, propDecorators: { imageSource: [{
                type: Input
            }], toggleLightBg: [{
                type: HostBinding,
                args: ['class.scu-backdrop-light-bg']
            }], toggleBg: [{
                type: HostBinding,
                args: ['class.scu-backdrop-bg']
            }] } });

function generateID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
}

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["DA"] = "da";
    LanguageEnum["NO"] = "no";
    LanguageEnum["NB"] = "no";
    LanguageEnum["NN"] = "no";
    LanguageEnum["SV"] = "sv";
    LanguageEnum["FI"] = "fi";
    LanguageEnum["EN"] = "en";
})(LanguageEnum || (LanguageEnum = {}));

var CountryEnum;
(function (CountryEnum) {
    CountryEnum["DK"] = "DK";
    CountryEnum["NO"] = "NO";
    CountryEnum["NB"] = "NO";
    CountryEnum["NN"] = "NO";
    CountryEnum["SE"] = "SE";
    CountryEnum["FI"] = "FI";
    CountryEnum["EN"] = "EN";
    CountryEnum["IS"] = "IS";
})(CountryEnum || (CountryEnum = {}));

function validateLanguage(language) {
    if (language === null || language === undefined) {
        return LanguageEnum.EN;
    }
    for (const enumLanguage in LanguageEnum) {
        if (language.toUpperCase().startsWith(enumLanguage.toUpperCase())) {
            return LanguageEnum[enumLanguage];
        }
    }
    return LanguageEnum.EN;
}
function filterLanguageToNordic(language) {
    const filtered = validateLanguage(language);
    return (filtered === LanguageEnum.EN ? LanguageEnum.DA : filtered);
}
function getBrowserLanguage() {
    const wn = window.navigator;
    const language = wn.language || wn.browserLanguage || wn.userLanguage;
    return validateLanguage(language);
}

class LanguageService {
    constructor(translate) {
        this.translate = translate;
        this.languageChange = new Subject();
    }
    setApplicationLanguage(language) {
        let lang;
        if (language !== undefined) {
            lang = language;
        }
        else {
            if (sessionStorage.getItem('language') === null) {
                lang = getBrowserLanguage();
            }
            else {
                lang = validateLanguage(sessionStorage.getItem('language'));
            }
        }
        sessionStorage.setItem('language', lang);
        this.translate.use(lang);
        this.translate.setDefaultLang(lang);
        this.languageChange.next(lang);
    }
    getCountryCode(language) {
        switch (language) {
            case 'no':
                return CountryEnum.NO;
            case 'fi':
                return CountryEnum.FI;
            case 'sv':
                return CountryEnum.SE;
            case 'en':
                return CountryEnum.EN;
            default:
                return CountryEnum.DK;
        }
    }
    getCountryEnum(language) {
        return CountryEnum[this.getCountryCode(language)];
    }
    getLanguageCode(country) {
        switch (country) {
            case 'NO':
                return LanguageEnum.NO;
            case 'FI':
                return LanguageEnum.FI;
            case 'SE':
                return LanguageEnum.SV;
            case 'EN':
                return LanguageEnum.EN;
            default:
                return LanguageEnum.DA;
        }
    }
    getDatePattern(language) {
        switch (language) {
            case LanguageEnum.NO:
                return 'DD-MM-ÅÅÅÅ';
            case LanguageEnum.DA:
                return 'DD-MM-ÅÅÅÅ';
            case LanguageEnum.SV:
                return 'DD-MM-ÅÅÅÅ';
            case LanguageEnum.FI:
                return 'DD-MM-YYYY';
            default:
                return 'DD-MM-YYYY';
        }
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.TranslateService }]; } });

/* tslint:disable */
/* eslint-disable */
/**
 * Global configuration
 */
class SOSCommonUIConfig {
    constructor() {
        this.enableCoBranding = false;
        this.colorTheme = {};
        this.enableGlassPaneOnHTTP = false;
        this.defaultSVGLibraryPath = 'assets/icons/icons_dynamic.svg';
        this.maskOptions = {};
    }
}
SOSCommonUIConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SOSCommonUIConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SOSCommonUIConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SOSCommonUIConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SOSCommonUIConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SvgIconService {
    constructor(http, configuration) {
        this.http = http;
        this.configuration = configuration;
        this.defaultPath = "assets/icons/icons_dynamic.svg";
        this.iconMap = new Map();
        if (configuration.defaultSVGLibraryPath) {
            this.defaultPath = configuration.defaultSVGLibraryPath;
        }
    }
    getIconXML(source, icon) {
        return new Promise((resolve, reject) => {
            this.getCollectionXML(source).then(svgCollection => {
                const document = this.toDocument(svgCollection);
                resolve(this.parseIcon(document, icon));
            }).catch(reason => reject(reason));
        });
    }
    getDefaultIconUrl() {
        if (this.configuration.enableCoBranding) {
            return 'brandicons/icons_dynamic.svg';
        }
        else {
            return this.defaultPath;
        }
    }
    getIcons(svgDocument) {
        const svgIDs = new Array();
        const symbolTags = svgDocument.getElementsByTagName("symbol");
        for (let i = 0; i < symbolTags.length; i++) {
            svgIDs.push(symbolTags.item(i).id);
        }
        return svgIDs;
    }
    parseIcon(svgCollection, icon) {
        const element = svgCollection.getElementById(icon);
        if (element) {
            return element;
        }
        else {
            const svgIcons = this.getIcons(svgCollection);
            let existingSymbolsMessage = "Existing SVGs:";
            for (let svgIcon of svgIcons) {
                existingSymbolsMessage = existingSymbolsMessage + " " + svgIcon;
            }
            throw new Error("Could not find svg icon: '" + icon + "'. " + existingSymbolsMessage);
        }
    }
    toDocument(svgCollection) {
        const parser = new DOMParser();
        return parser.parseFromString(svgCollection, "application/xml");
    }
    getCollectionXML(source) {
        return new Promise((resolve, reject) => {
            if (this.iconMap.has(source)) {
                resolve(this.iconMap.get(source));
            }
            else {
                if (!source) {
                    source = this.getDefaultIconUrl();
                }
                this.http.get(source, { responseType: "text" }).subscribe({
                    next: iconCollectionXml => {
                        this.iconMap.set(source, iconCollectionXml);
                        resolve(iconCollectionXml);
                    },
                    error: err => reject(err)
                });
            }
        });
    }
}
SvgIconService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SvgIconService, deps: [{ token: i1$3.HttpClient }, { token: SOSCommonUIConfig }], target: i0.ɵɵFactoryTarget.Injectable });
SvgIconService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SvgIconService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SvgIconService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: SOSCommonUIConfig }]; } });

class SvgIconRendererDirective {
    constructor(renderer, elementRef, configuration, svgIconService) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.configuration = configuration;
        this.svgIconService = svgIconService;
    }
    ngOnInit() {
        if (this.renderedicon === null || this.renderedicon === undefined) {
            throw new Error("Attribute 'icon' is required");
        }
        this.generateUseElement();
    }
    generateUseElement() {
        this.svgIconService.getIconXML(this.source, this.renderedicon).then(htmlElement => {
            const htmlChildren = htmlElement.children;
            this.setAttributeFromElement(htmlElement, "viewBox");
            this.setAttributeFromElement(htmlElement, "width");
            this.setAttributeFromElement(htmlElement, "height");
            for (let i = 0; i < htmlChildren.length; i++) {
                this.renderer.appendChild(this.elementRef.nativeElement, htmlChildren.item(i));
            }
        });
    }
    setAttributeFromElement(htmlElement, attribute) {
        if (htmlElement.hasAttribute(attribute)) {
            this.renderer.setAttribute(this.elementRef.nativeElement, attribute, htmlElement.getAttribute(attribute));
        }
    }
    ngOnDestroy() {
    }
}
SvgIconRendererDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SvgIconRendererDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: SOSCommonUIConfig }, { token: SvgIconService }], target: i0.ɵɵFactoryTarget.Directive });
SvgIconRendererDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: SvgIconRendererDirective, selector: "svg[renderedicon]", inputs: { source: "source", renderedicon: "renderedicon" }, exportAs: ["SvgIconRenderer"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SvgIconRendererDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'svg[renderedicon]',
                    exportAs: 'SvgIconRenderer'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: SOSCommonUIConfig }, { type: SvgIconService }]; }, propDecorators: { source: [{
                type: Input
            }], renderedicon: [{
                type: Input
            }] } });

class TestDataPipe {
    transform(prefix, ...values) {
        let result = prefix;
        values.forEach(x => {
            result += '-' + String(x).replace(/\s/g, '');
        });
        return result.replace(/[A-Z]/g, (value, index) => (index ? '-' : '') + value.toLowerCase());
    }
}
TestDataPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TestDataPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TestDataPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: TestDataPipe, name: "createTestId" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TestDataPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'createTestId' }]
        }] });

class BurgerMenuComponent {
    set selectedItem(value) {
        this.currentItem = value;
        this.selectedModelItem = this.getModelFromItem();
    }
    get selectedItem() {
        return this.currentItem;
    }
    constructor(control, translate, languageService) {
        this.control = control;
        this.translate = translate;
        this.languageService = languageService;
        this.languageCallback = () => {
            this.languageChangeSubscription = this.languageService.languageChange.subscribe(lang => this.selectedLanguage = lang);
        };
        this.onLanguageSelectCallback = (language) => {
            this.languageService.setApplicationLanguage(language);
        };
        this.selectedLanguage = 'da';
        this.id = generateID();
        this.buttonText = undefined;
        this.languageItems = new Array();
        this.actionItems = new Array();
        this.displayCookieButton = false;
        this.displayLogout = false;
        /**
         * @deprecated The input should not be used. Use the marker classes instead
         */
        this.dropdownLabelClasses = '';
        /**
         * @deprecated This setting is no longer used and will be removed
         */
        this.dropdownItemClasses = 'text-24';
        this.openIcon = '3_line_menu';
        this.closeIcon = 'cross_with_hover';
        this.dataTestId = 'burger-menu';
        this.isOpen = new EventEmitter();
        this.optionSelected = new EventEmitter();
        this.logoutClicked = new EventEmitter();
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }
    writeValue(value) {
        this.selectedLanguage = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnInit() {
        this.selectedLanguage = this.translate.getDefaultLang();
        for (const languageItem of this.languageItems) {
            if (languageItem.languageCode === this.selectedLanguage) {
                this.selectItem(languageItem);
            }
        }
        this.languageCallback();
    }
    ngOnDestroy() {
        if (this.languageChangeSubscription) {
            this.languageChangeSubscription?.unsubscribe();
        }
    }
    selectItem(modelItem) {
        this.selectedModelItem = modelItem;
        this.onLanguageSelectCallback(modelItem.languageCode);
        this.onSelectOption();
        if (this.control) {
            this.onChange(modelItem.languageCode);
        }
    }
    onSelectOption() {
        if (this.control) {
            this.onChange(this.selectedModelItem?.languageCode);
        }
        this.optionSelected.emit(this.selectedModelItem?.languageCode);
    }
    isSelected(modelItem) {
        return modelItem === this.selectedModelItem;
    }
    buttonName() {
        if (this.buttonText) {
            return this.buttonText;
        }
        else {
            return this.selectedModelItem ? this.selectedModelItem.translationKeyShort : '';
        }
    }
    setOpen(open) {
        this.showGlasspane = open;
        this.isOpen.emit(open);
    }
    getLanguageItemClasses(languageItem) {
        let classes = 'language-item';
        if (this.isSelected(languageItem)) {
            classes = classes + ' active';
        }
        if (languageItem.classes) {
            classes = classes + ' ' + languageItem.classes;
        }
        return classes;
    }
    getActionItemClasses(actionItem) {
        let classes = 'action-item';
        if (actionItem.classes) {
            classes = classes + ' ' + actionItem.classes;
        }
        return classes;
    }
    isLoggedIn() {
        if (this.getJWTToken()) {
            return true;
        }
        else {
            return false;
        }
    }
    getLoggedInName() {
        const jwtToken = this.getJWTToken();
        if (jwtToken) {
            const parsedToken = parseJwt(jwtToken);
            return parsedToken.name;
        }
        else {
            return '';
        }
    }
    getJWTToken() {
        if (this.jwtToken) {
            if (typeof this.jwtToken === 'string') {
                return this.jwtToken;
            }
            else {
                const methodResponse = this.jwtToken();
                if (methodResponse) {
                    return methodResponse;
                }
            }
        }
        return undefined;
    }
    displayLogoutFooter() {
        return this.displayLogout && this.isLoggedIn();
    }
    getModelFromItem() {
        for (const modelItem of this.languageItems) {
            if (isEqual(modelItem.languageCode, this.selectedItem)) {
                return modelItem;
            }
        }
        return undefined;
    }
}
BurgerMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BurgerMenuComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i2.TranslateService }, { token: LanguageService }], target: i0.ɵɵFactoryTarget.Component });
BurgerMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BurgerMenuComponent, selector: "scu-burger-menu", inputs: { languageCallback: "languageCallback", onLanguageSelectCallback: "onLanguageSelectCallback", selectedLanguage: "selectedLanguage", formControlName: "formControlName", id: "id", buttonText: "buttonText", languageItems: "languageItems", actionItems: "actionItems", displayCookieButton: "displayCookieButton", displayLogout: "displayLogout", dropdownLabelClasses: "dropdownLabelClasses", dropdownItemClasses: "dropdownItemClasses", iconSource: "iconSource", openIcon: "openIcon", closeIcon: "closeIcon", dataTestId: "dataTestId", jwtToken: "jwtToken", selectedItem: "selectedItem" }, outputs: { isOpen: "isOpen", optionSelected: "optionSelected", logoutClicked: "logoutClicked" }, ngImport: i0, template: "<div ngbDropdown #myDrop=\"ngbDropdown\" display=\"static\" class=\"burger-menu\"\n     (openChange)=\"setOpen($event)\">\n  <button type=\"button\" class=\"btn p-0 flex-content justify-content-between menu-button no-active\" id=\"{{id}}\" ngbDropdownToggle [attr.data-test]=\"dataTestId\">\n    <span [ngClass]=\"dropdownLabelClasses\" class=\"pe-3 menu-button-label\">{{selectedLanguage.toUpperCase()}}</span><svg class=\"icon-open\" [source]=\"iconSource\" renderedicon=\"{{openIcon}}\"></svg>\n  </button>\n  <div ngbDropdownMenu aria-labelledby=\"id\" class=\"flex\">\n\n    <div class=\"top-menu\">\n      <span role=\"button\" (click)=\"$event.stopPropagation(); myDrop.close()\">\n        <svg class=\"icon-close\" [source]=\"iconSource\" renderedicon=\"{{closeIcon}}\"></svg>\n      </span>\n    </div>\n\n    <div>\n      <button *ngFor=\"let actionItem of actionItems; index as i\"  id=\"{{actionItem.id}}\"\n              ngbDropdownItem\n              [ngClass]=\"getActionItemClasses(actionItem)\"\n              [attr.data-test]=\"dataTestId | createTestId :'action-item' :i\"\n              (click)=\"actionItem.action(); myDrop.close();\">\n        {{ actionItem.translationKey | translate }}\n      </button>\n    </div>\n\n    <h1 class=\"dropdown-item-text\">{{\"general.languageHeader\" | translate}}</h1>\n    <div>\n      <button *ngFor=\"let languageItem of languageItems; index as i\" type=\"button\" id=\"{{languageItem.id}}\"\n              ngbDropdownItem\n              [ngClass]=\"getLanguageItemClasses(languageItem)\"\n              [attr.aria-current]='isSelected(languageItem) ? \"true\" : \"false\"'\n              [attr.data-test]=\"dataTestId | createTestId :'language-item' :i\"\n              (click)=\"selectItem(languageItem)\">\n        {{languageItem.translationKeyLong | translate}}\n      </button>\n    </div>\n\n    <div class=\"menu-footer mt-auto d-flex flex-column align-items-start\">\n      <button class=\"cookie-info-open\" id=\"burger-menu-cookie-info-open\" *ngIf=\"displayCookieButton\" (click)=\"myDrop.close()\">\n        <a href=\"javascript: Cookiebot.renew()\">{{ 'cookiebot.cookiebot' | translate }}</a>\n      </button>\n      <button class=\"logout-button\" *ngIf=\"displayLogoutFooter()\" (click)=\"logoutClicked.emit(); myDrop.close();\">\n        {{\"general.logout\" | translate}} {{this.getLoggedInName()}}\n      </button>\n    </div>\n  </div>\n\n</div>\n\n<ng-container *ngIf=\"this.showGlasspane\">\n  <div class=\"glasspane fullscreen\"></div>\n</ng-container>", styles: [".dropdown-toggle:after{content:none}.icon-open{width:1.5rem}::ng-deep svg.icon-close .icon,::ng-deep svg.icon-close .icon-stroke{stroke:rgb(var(--scu-secondary-dark))}::ng-deep svg.icon-close .background-fill,::ng-deep svg.icon-close .background{fill:transparent}::ng-deep svg.icon-close:hover .background-fill,::ng-deep svg.icon-close:hover .background{fill:rgb(var(--scu-tertiary-faded))}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "popperOptions", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { kind: "directive", type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { kind: "directive", type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { kind: "directive", type: i1$2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }, { kind: "directive", type: SvgIconRendererDirective, selector: "svg[renderedicon]", inputs: ["source", "renderedicon"], exportAs: ["SvgIconRenderer"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BurgerMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-burger-menu', template: "<div ngbDropdown #myDrop=\"ngbDropdown\" display=\"static\" class=\"burger-menu\"\n     (openChange)=\"setOpen($event)\">\n  <button type=\"button\" class=\"btn p-0 flex-content justify-content-between menu-button no-active\" id=\"{{id}}\" ngbDropdownToggle [attr.data-test]=\"dataTestId\">\n    <span [ngClass]=\"dropdownLabelClasses\" class=\"pe-3 menu-button-label\">{{selectedLanguage.toUpperCase()}}</span><svg class=\"icon-open\" [source]=\"iconSource\" renderedicon=\"{{openIcon}}\"></svg>\n  </button>\n  <div ngbDropdownMenu aria-labelledby=\"id\" class=\"flex\">\n\n    <div class=\"top-menu\">\n      <span role=\"button\" (click)=\"$event.stopPropagation(); myDrop.close()\">\n        <svg class=\"icon-close\" [source]=\"iconSource\" renderedicon=\"{{closeIcon}}\"></svg>\n      </span>\n    </div>\n\n    <div>\n      <button *ngFor=\"let actionItem of actionItems; index as i\"  id=\"{{actionItem.id}}\"\n              ngbDropdownItem\n              [ngClass]=\"getActionItemClasses(actionItem)\"\n              [attr.data-test]=\"dataTestId | createTestId :'action-item' :i\"\n              (click)=\"actionItem.action(); myDrop.close();\">\n        {{ actionItem.translationKey | translate }}\n      </button>\n    </div>\n\n    <h1 class=\"dropdown-item-text\">{{\"general.languageHeader\" | translate}}</h1>\n    <div>\n      <button *ngFor=\"let languageItem of languageItems; index as i\" type=\"button\" id=\"{{languageItem.id}}\"\n              ngbDropdownItem\n              [ngClass]=\"getLanguageItemClasses(languageItem)\"\n              [attr.aria-current]='isSelected(languageItem) ? \"true\" : \"false\"'\n              [attr.data-test]=\"dataTestId | createTestId :'language-item' :i\"\n              (click)=\"selectItem(languageItem)\">\n        {{languageItem.translationKeyLong | translate}}\n      </button>\n    </div>\n\n    <div class=\"menu-footer mt-auto d-flex flex-column align-items-start\">\n      <button class=\"cookie-info-open\" id=\"burger-menu-cookie-info-open\" *ngIf=\"displayCookieButton\" (click)=\"myDrop.close()\">\n        <a href=\"javascript: Cookiebot.renew()\">{{ 'cookiebot.cookiebot' | translate }}</a>\n      </button>\n      <button class=\"logout-button\" *ngIf=\"displayLogoutFooter()\" (click)=\"logoutClicked.emit(); myDrop.close();\">\n        {{\"general.logout\" | translate}} {{this.getLoggedInName()}}\n      </button>\n    </div>\n  </div>\n\n</div>\n\n<ng-container *ngIf=\"this.showGlasspane\">\n  <div class=\"glasspane fullscreen\"></div>\n</ng-container>", styles: [".dropdown-toggle:after{content:none}.icon-open{width:1.5rem}::ng-deep svg.icon-close .icon,::ng-deep svg.icon-close .icon-stroke{stroke:rgb(var(--scu-secondary-dark))}::ng-deep svg.icon-close .background-fill,::ng-deep svg.icon-close .background{fill:transparent}::ng-deep svg.icon-close:hover .background-fill,::ng-deep svg.icon-close:hover .background{fill:rgb(var(--scu-tertiary-faded))}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i2.TranslateService }, { type: LanguageService }]; }, propDecorators: { languageCallback: [{
                type: Input
            }], onLanguageSelectCallback: [{
                type: Input
            }], selectedLanguage: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], id: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], languageItems: [{
                type: Input
            }], actionItems: [{
                type: Input
            }], displayCookieButton: [{
                type: Input
            }], displayLogout: [{
                type: Input
            }], dropdownLabelClasses: [{
                type: Input
            }], dropdownItemClasses: [{
                type: Input
            }], iconSource: [{
                type: Input
            }], openIcon: [{
                type: Input
            }], closeIcon: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], jwtToken: [{
                type: Input
            }], selectedItem: [{
                type: Input
            }], isOpen: [{
                type: Output
            }], optionSelected: [{
                type: Output
            }], logoutClicked: [{
                type: Output
            }] } });

class HeaderComponent {
    get setMainElement() {
        return true;
    }
    constructor() {
        this.showCookieButton = true;
        this.showMenuCookieButton = false;
        this.hideMenu = false;
        this.imageSourceLogo = '';
        this.clickOnLogo = new EventEmitter();
        this.languageSelections = [{ translationKeyShort: 'general.language.short.da', translationKeyLong: 'general.language.long.da', languageCode: 'da' },
            { translationKeyShort: 'general.language.short.no', translationKeyLong: 'general.language.long.no', languageCode: 'no' }, { translationKeyShort: 'general.language.short.sv', translationKeyLong: 'general.language.long.sv', languageCode: 'sv' },
            { translationKeyShort: 'general.language.short.fi', translationKeyLong: 'general.language.long.fi', languageCode: 'fi' }, { translationKeyShort: 'general.language.short.en', translationKeyLong: 'general.language.long.en', languageCode: 'en' }];
        this.actionButtons = [];
        this.openIcon = '3_line_menu';
        this.closeIcon = 'cross_with_hover';
        this.heightClass = 'my-5';
        this.cookieCssClass = '';
        this.displayMenuCookieButton = false;
        this.displayMenuLogout = false;
        this.isBurgerMenuOpen = new EventEmitter();
        this.menuLogoutClicked = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
    }
    clickedOnLogo() {
        this.clickOnLogo.emit();
    }
    emitBurgerOpen(isBurgerMenuOpenEvent) {
        this.isBurgerMenuOpen.emit(isBurgerMenuOpenEvent);
    }
    logoutClicked() {
        this.menuLogoutClicked.emit();
    }
}
HeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: HeaderComponent, selector: "scu-header", inputs: { menuButtonText: "menuButtonText", menuDataTestId: "menuDataTestId", showCookieButton: "showCookieButton", showMenuCookieButton: "showMenuCookieButton", hideMenu: "hideMenu", imageSourceLogo: "imageSourceLogo", languageSelections: "languageSelections", actionButtons: "actionButtons", openIcon: "openIcon", closeIcon: "closeIcon", menuIconSource: "menuIconSource", heightClass: "heightClass", cookieCssClass: "cookieCssClass", displayMenuCookieButton: "displayMenuCookieButton", displayMenuLogout: "displayMenuLogout", menuJwtToken: "menuJwtToken" }, outputs: { clickOnLogo: "clickOnLogo", isBurgerMenuOpen: "isBurgerMenuOpen", menuLogoutClicked: "menuLogoutClicked" }, host: { properties: { "class.main-element": "this.setMainElement" } }, ngImport: i0, template: "<div class=\"element-outlet d-flex justify-content-between align-items-center my-xs-0\" [ngClass]=\"heightClass\">\n\n    <scu-sos-logo (clickAction)=\"clickedOnLogo()\" [imageSource]=\"imageSourceLogo\" ></scu-sos-logo>\n    <div class=\"d-flex flex-row justify-content-end align-items-center\">\n      <button class=\"cookie-info-open py-1 me-4\" id=\"cookie-info-open\" *ngIf=\"showCookieButton\" [ngClass]=\"cookieCssClass\">\n        <a href=\"javascript: Cookiebot.renew()\">{{ 'cookiebot.cookiebot' | translate }}</a>\n      </button>\n\n      <scu-burger-menu *ngIf=\"!hideMenu\"\n                       [buttonText]=\"menuButtonText\"\n                       [languageItems]=\"languageSelections\"\n                       [actionItems]=\"actionButtons\"\n                       [openIcon]=\"openIcon\"\n                       [closeIcon]=\"closeIcon\"\n                       [iconSource]=\"menuIconSource\"\n                       [displayCookieButton]=\"displayMenuCookieButton\"\n                       [displayLogout]=\"displayMenuCookieButton\"\n                       [jwtToken]=\"menuJwtToken\"\n                       [dataTestId]=\"menuDataTestId\"\n                       (isOpen)=\"emitBurgerOpen($event)\"\n                       (logoutClicked)=\"logoutClicked()\"\n                       >\n      </scu-burger-menu>\n    </div>\n\n</div>\n", styles: [":host{background-color:rgb(var(--scu-backdrop-light));display:flex}::ng-deep .cookie-info-open.url-item{width:6.5rem!important;margin-left:2.2rem;padding:.35rem .3rem!important;--bs-dropdown-link-hover-bg: rgb(var(--scu-primary))}::ng-deep .cookie-info-open.url-item a{color:rgb(var(--scu-backdrop-light))!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SosLogoComponent, selector: "scu-sos-logo", inputs: ["poweredByText", "imageSource", "dataTestId"], outputs: ["clickAction"] }, { kind: "component", type: BurgerMenuComponent, selector: "scu-burger-menu", inputs: ["languageCallback", "onLanguageSelectCallback", "selectedLanguage", "formControlName", "id", "buttonText", "languageItems", "actionItems", "displayCookieButton", "displayLogout", "dropdownLabelClasses", "dropdownItemClasses", "iconSource", "openIcon", "closeIcon", "dataTestId", "jwtToken", "selectedItem"], outputs: ["isOpen", "optionSelected", "logoutClicked"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-header', template: "<div class=\"element-outlet d-flex justify-content-between align-items-center my-xs-0\" [ngClass]=\"heightClass\">\n\n    <scu-sos-logo (clickAction)=\"clickedOnLogo()\" [imageSource]=\"imageSourceLogo\" ></scu-sos-logo>\n    <div class=\"d-flex flex-row justify-content-end align-items-center\">\n      <button class=\"cookie-info-open py-1 me-4\" id=\"cookie-info-open\" *ngIf=\"showCookieButton\" [ngClass]=\"cookieCssClass\">\n        <a href=\"javascript: Cookiebot.renew()\">{{ 'cookiebot.cookiebot' | translate }}</a>\n      </button>\n\n      <scu-burger-menu *ngIf=\"!hideMenu\"\n                       [buttonText]=\"menuButtonText\"\n                       [languageItems]=\"languageSelections\"\n                       [actionItems]=\"actionButtons\"\n                       [openIcon]=\"openIcon\"\n                       [closeIcon]=\"closeIcon\"\n                       [iconSource]=\"menuIconSource\"\n                       [displayCookieButton]=\"displayMenuCookieButton\"\n                       [displayLogout]=\"displayMenuCookieButton\"\n                       [jwtToken]=\"menuJwtToken\"\n                       [dataTestId]=\"menuDataTestId\"\n                       (isOpen)=\"emitBurgerOpen($event)\"\n                       (logoutClicked)=\"logoutClicked()\"\n                       >\n      </scu-burger-menu>\n    </div>\n\n</div>\n", styles: [":host{background-color:rgb(var(--scu-backdrop-light));display:flex}::ng-deep .cookie-info-open.url-item{width:6.5rem!important;margin-left:2.2rem;padding:.35rem .3rem!important;--bs-dropdown-link-hover-bg: rgb(var(--scu-primary))}::ng-deep .cookie-info-open.url-item a{color:rgb(var(--scu-backdrop-light))!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { menuButtonText: [{
                type: Input
            }], menuDataTestId: [{
                type: Input
            }], showCookieButton: [{
                type: Input
            }], showMenuCookieButton: [{
                type: Input
            }], hideMenu: [{
                type: Input
            }], imageSourceLogo: [{
                type: Input
            }], clickOnLogo: [{
                type: Output
            }], languageSelections: [{
                type: Input
            }], actionButtons: [{
                type: Input
            }], openIcon: [{
                type: Input
            }], closeIcon: [{
                type: Input
            }], menuIconSource: [{
                type: Input
            }], heightClass: [{
                type: Input
            }], cookieCssClass: [{
                type: Input
            }], displayMenuCookieButton: [{
                type: Input
            }], displayMenuLogout: [{
                type: Input
            }], menuJwtToken: [{
                type: Input
            }], isBurgerMenuOpen: [{
                type: Output
            }], menuLogoutClicked: [{
                type: Output
            }], setMainElement: [{
                type: HostBinding,
                args: ['class.main-element']
            }] } });

class ExtendableRadioListComponent {
    constructor() {
        this.role = 'custom-border-list';
        this.controlId = generateID();
        this.name = 'radio_list';
        this.listElementClasses = '';
        this.borderElementClasses = '';
        this.radioButtonClasses = '';
        this.labelClasses = 'ps-1';
        this.dataTest = 'ExtendableRadioList';
    }
    getValue(item) {
        if (!item) {
            return undefined;
        }
        if (this.valueAttr) {
            return item[this.valueAttr];
        }
        else {
            return item;
        }
    }
    displayDropdownArea(toTest) {
        const testVal = this.getValue(toTest);
        const expectedVal = this.control.value;
        return testVal === expectedVal;
    }
}
ExtendableRadioListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExtendableRadioListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ExtendableRadioListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ExtendableRadioListComponent, selector: "scu-extendable-radio-list", inputs: { controlId: "controlId", name: "name", items: "items", control: "control", valueAttr: "valueAttr", listElementClasses: "listElementClasses", borderElementClasses: "borderElementClasses", radioButtonClasses: "radioButtonClasses", labelClasses: "labelClasses", dataTest: "dataTest" }, host: { properties: { "class": "this.role" } }, queries: [{ propertyName: "itemFormat", first: true, predicate: ["itemFormat"], descendants: true }, { propertyName: "activeArea", first: true, predicate: ["activeArea"], descendants: true }], ngImport: i0, template: "<div *ngFor=\"let item of items; index as i\" class=\"list-element border-list\" [ngClass]=\"listElementClasses\">\n  <div class=\"form-check border-element p-0\" [ngClass]=\"borderElementClasses\" >\n    <input class=\"form-check-input m-3\"\n           [ngClass]=\"radioButtonClasses\"\n           type=\"radio\"\n           name=\"{{name}}\"\n           id=\"{{controlId+i}}\"\n           [formControl]=\"control\"\n           value='{{getValue(item)}}'\n           [attr.data-test]=\"dataTest | createTestId :getValue(item) :i\">\n    <label class = \"form-check-label\" [ngClass]=\"labelClasses\" for='{{controlId+i}}'>\n      <ng-container [ngTemplateOutlet]=\"itemFormat\"\n                    [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i, index: i}\"></ng-container>\n    </label>\n  </div>\n  <div *ngIf=\"displayDropdownArea(item)\" class=\"d-block border-element\" [ngClass]=\"borderElementClasses\">\n    <ng-container [ngTemplateOutlet]=\"activeArea\"\n                  [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i, index: i}\"></ng-container>\n  </div>\n\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExtendableRadioListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-extendable-radio-list', template: "<div *ngFor=\"let item of items; index as i\" class=\"list-element border-list\" [ngClass]=\"listElementClasses\">\n  <div class=\"form-check border-element p-0\" [ngClass]=\"borderElementClasses\" >\n    <input class=\"form-check-input m-3\"\n           [ngClass]=\"radioButtonClasses\"\n           type=\"radio\"\n           name=\"{{name}}\"\n           id=\"{{controlId+i}}\"\n           [formControl]=\"control\"\n           value='{{getValue(item)}}'\n           [attr.data-test]=\"dataTest | createTestId :getValue(item) :i\">\n    <label class = \"form-check-label\" [ngClass]=\"labelClasses\" for='{{controlId+i}}'>\n      <ng-container [ngTemplateOutlet]=\"itemFormat\"\n                    [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i, index: i}\"></ng-container>\n    </label>\n  </div>\n  <div *ngIf=\"displayDropdownArea(item)\" class=\"d-block border-element\" [ngClass]=\"borderElementClasses\">\n    <ng-container [ngTemplateOutlet]=\"activeArea\"\n                  [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i, index: i}\"></ng-container>\n  </div>\n\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['class']
            }], itemFormat: [{
                type: ContentChild,
                args: ['itemFormat']
            }], activeArea: [{
                type: ContentChild,
                args: ['activeArea']
            }], controlId: [{
                type: Input
            }], name: [{
                type: Input
            }], items: [{
                type: Input
            }], control: [{
                type: Input
            }], valueAttr: [{
                type: Input
            }], listElementClasses: [{
                type: Input
            }], borderElementClasses: [{
                type: Input
            }], radioButtonClasses: [{
                type: Input
            }], labelClasses: [{
                type: Input
            }], dataTest: [{
                type: Input
            }] } });

class RadioButtonListComponent {
    constructor() {
        this.controlId = generateID();
        this.name = 'radio_button_list';
        this.clickAction = new EventEmitter();
        this.labelClasses = 'ms-1';
        this.radioButtonClasses = '';
        this.wrapperClasses = '';
        this.dataTest = 'RadioButtonList';
    }
    onSelectOption($event) {
        this.clickAction.emit($event);
    }
}
RadioButtonListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadioButtonListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RadioButtonListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RadioButtonListComponent, selector: "scu-radio-button-list", inputs: { controlId: "controlId", name: "name", items: "items", control: "control", labelClasses: "labelClasses", radioButtonClasses: "radioButtonClasses", wrapperClasses: "wrapperClasses", dataTest: "dataTest" }, outputs: { clickAction: "clickAction" }, queries: [{ propertyName: "itemFormat", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<ng-container *ngFor=\"let item of items; index as i\">\n  <div class=\"form-check mb-0 ps-0\"\n    [ngClass]=\"wrapperClasses\">\n    <input class=\"form-check-input\"\n           [ngClass]=\"radioButtonClasses\"\n           type=\"radio\"\n           name=\"{{name}}\"\n           (click)=\"onSelectOption(item)\"\n           id=\"{{controlId+i}}\"\n           [formControl]=\"control\"\n           value='{{item}}'\n           [attr.data-test]=\"dataTest | createTestId :item :i\">\n    <label [ngClass]=\"labelClasses\" class=\"form-check-label\" for='{{controlId+i}}'>\n      <ng-container [ngTemplateOutlet]=\"itemFormat\"\n                    [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i}\"></ng-container>\n    </label>\n\n  </div>\n</ng-container>\n", styles: [".form-check-input{margin:.75rem}.form-check-label{margin-top:.75rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadioButtonListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-radio-button-list', template: "<ng-container *ngFor=\"let item of items; index as i\">\n  <div class=\"form-check mb-0 ps-0\"\n    [ngClass]=\"wrapperClasses\">\n    <input class=\"form-check-input\"\n           [ngClass]=\"radioButtonClasses\"\n           type=\"radio\"\n           name=\"{{name}}\"\n           (click)=\"onSelectOption(item)\"\n           id=\"{{controlId+i}}\"\n           [formControl]=\"control\"\n           value='{{item}}'\n           [attr.data-test]=\"dataTest | createTestId :item :i\">\n    <label [ngClass]=\"labelClasses\" class=\"form-check-label\" for='{{controlId+i}}'>\n      <ng-container [ngTemplateOutlet]=\"itemFormat\"\n                    [ngTemplateOutletContext]=\"{$implicit: item, id: controlId+i}\"></ng-container>\n    </label>\n\n  </div>\n</ng-container>\n", styles: [".form-check-input{margin:.75rem}.form-check-label{margin-top:.75rem}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { itemFormat: [{
                type: ContentChild,
                args: [TemplateRef]
            }], controlId: [{
                type: Input
            }], name: [{
                type: Input
            }], items: [{
                type: Input
            }], control: [{
                type: Input
            }], clickAction: [{
                type: Output
            }], labelClasses: [{
                type: Input
            }], radioButtonClasses: [{
                type: Input
            }], wrapperClasses: [{
                type: Input
            }], dataTest: [{
                type: Input
            }] } });

/*
This component is a text-area with sos-style
The following properties can be used.
formControl: The formControl for the formElement in the component (*)
placeholder: An optional placeholder text
maxLength: Maximum number af characters to allow in the text-area (default: 500)
rows: Number of rows in the text-area (default: 8)
applyStyleOnFocus: Set this to false if no style should be applied when the text-area is on focus (default: true)
displayBorder: Set this to false if no borders should be drawn (default: true)
error: Set to true if the field should make a visual indication of an error value (default: false)

Output:
onFocus: Fired when to text-ares receives focus
onFocusOut: Fired when to text-area loses focus

 */
class TextAreaComponent {
    constructor() {
        this.placeholder = '';
        this.maxLength = 500;
        this.rows = 8;
        this.applyStyleOnFocus = true;
        this.displayBorder = true;
        this.error = false;
        this.dataTest = 'TextArea';
        this.onFocus = new EventEmitter();
        this.onFocusOut = new EventEmitter();
        this.value = '';
        this.currentCount = 0;
    }
    ngOnInit() {
        this.uiFocused = false;
        if (this.control !== undefined && this.control !== null) {
            this.value = this.control?.value || '';
        }
        this.currentCount = this.value.length;
    }
    _onFocus(event) {
        this.uiFocused = this.applyStyleOnFocus;
        this.onFocus.emit(event);
    }
    _onFocusOut(event) {
        this.uiFocused = false;
        this.onFocusOut.emit(event);
    }
    _keyup(event) {
        this.currentCount = this.control?.value?.length;
    }
}
TextAreaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextAreaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextAreaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TextAreaComponent, selector: "scu-text-area", inputs: { control: "control", placeholder: "placeholder", maxLength: "maxLength", rows: "rows", applyStyleOnFocus: "applyStyleOnFocus", displayBorder: "displayBorder", error: "error", dataTest: "dataTest" }, outputs: { onFocus: "onFocus", onFocusOut: "onFocusOut" }, ngImport: i0, template: "<div class=\"text-with-counter vertical-input-group d-flex flex-column\" [ngClass]=\"{focused: uiFocused, 'no-border': !displayBorder}\">\n  <div class=\"input-group textarea-wrapper flex-grow-1 flex-shrink-0 overflow-hidden\" style=\"position: relative\">\n    <textarea class=\"form-control text-16\" (focusin)=\"_onFocus($event)\" (focusout)=\"_onFocusOut($event)\"\n              [formControl]=\"control\" (keyup)=\"_keyup($event)\" maxlength=\"{{maxLength}}\"\n              placeholder=\"{{placeholder}}\" [ngClass]=\"{'text-danger': error}\" rows=\"{{rows}}\"\n              [attr.data-test]=\"dataTest\"></textarea>\n  </div>\n  <div class=\"input-group input-wrapper overflow-hidden\">\n    <input type=\"text\" disabled class=\"sos-style form-control text-14 no-hover\" [ngClass]=\"{'text-danger': error}\" value=\"{{currentCount}}/{{maxLength}}\">\n  </div>\n</div>\n", styles: [".text-with-counter{height:100%}.text-with-counter .textarea-wrapper textarea{resize:none;border-width:1px 1px 0 1px;box-sizing:border-box}.text-with-counter input[type=text]:disabled{background-color:rgba(var(--scu-backdrop-light),var(--bs-bg-opacity, 1));text-align:right;margin-bottom:0;padding:20px}.text-with-counter .input-group *{border-width:0 1px 1px 1px;border-color:rgb(var(--scu-secondary-light))}.text-with-counter.no-border .input-group *{border:none;border-radius:0}.vertical-input-group .input-group:first-child *{border-bottom-left-radius:0;border-bottom-right-radius:0}.vertical-input-group .input-group:last-child *{border-top-left-radius:0;border-top-right-radius:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-text-area', template: "<div class=\"text-with-counter vertical-input-group d-flex flex-column\" [ngClass]=\"{focused: uiFocused, 'no-border': !displayBorder}\">\n  <div class=\"input-group textarea-wrapper flex-grow-1 flex-shrink-0 overflow-hidden\" style=\"position: relative\">\n    <textarea class=\"form-control text-16\" (focusin)=\"_onFocus($event)\" (focusout)=\"_onFocusOut($event)\"\n              [formControl]=\"control\" (keyup)=\"_keyup($event)\" maxlength=\"{{maxLength}}\"\n              placeholder=\"{{placeholder}}\" [ngClass]=\"{'text-danger': error}\" rows=\"{{rows}}\"\n              [attr.data-test]=\"dataTest\"></textarea>\n  </div>\n  <div class=\"input-group input-wrapper overflow-hidden\">\n    <input type=\"text\" disabled class=\"sos-style form-control text-14 no-hover\" [ngClass]=\"{'text-danger': error}\" value=\"{{currentCount}}/{{maxLength}}\">\n  </div>\n</div>\n", styles: [".text-with-counter{height:100%}.text-with-counter .textarea-wrapper textarea{resize:none;border-width:1px 1px 0 1px;box-sizing:border-box}.text-with-counter input[type=text]:disabled{background-color:rgba(var(--scu-backdrop-light),var(--bs-bg-opacity, 1));text-align:right;margin-bottom:0;padding:20px}.text-with-counter .input-group *{border-width:0 1px 1px 1px;border-color:rgb(var(--scu-secondary-light))}.text-with-counter.no-border .input-group *{border:none;border-radius:0}.vertical-input-group .input-group:first-child *{border-bottom-left-radius:0;border-bottom-right-radius:0}.vertical-input-group .input-group:last-child *{border-top-left-radius:0;border-top-right-radius:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { control: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], rows: [{
                type: Input
            }], applyStyleOnFocus: [{
                type: Input
            }], displayBorder: [{
                type: Input
            }], error: [{
                type: Input
            }], dataTest: [{
                type: Input
            }], onFocus: [{
                type: Output
            }], onFocusOut: [{
                type: Output
            }] } });

function consistsOf(object, keys) {
    if (object === undefined) {
        return false;
    }
    let keyFound = false;
    for (const key of Object.keys(object)) {
        const castKey = key;
        if (!keys.includes(castKey)) {
            return false;
        }
        else {
            keyFound = true;
        }
    }
    return keyFound;
}

class CustomDateParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    format(date) {
        let result = null;
        if (date) {
            result = padNumber(date.day) + this.DELIMITER + padNumber(date.month) + this.DELIMITER + date.year;
        }
        return result;
    }
    parse(value) {
        let result = null;
        if (value) {
            const date = value.split(this.DELIMITER);
            result = {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return result;
    }
}
CustomDateParserFormatter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomDateParserFormatter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CustomDateParserFormatter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomDateParserFormatter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CustomDateParserFormatter, decorators: [{
            type: Injectable
        }] });
function padNumber(value) {
    if (value !== null && !isNaN(value)) {
        return `0${value}`.slice(-2);
    }
    return '';
}

class DatepickerLanguage extends NgbDatepickerI18nDefault {
    constructor(calendar, translate) {
        super('en');
        this.translate = translate;
        this.monthsMap = {
            1: 'jan',
            2: 'feb',
            3: 'mar',
            4: 'apr',
            5: 'may',
            6: 'jun',
            7: 'jul',
            8: 'aug',
            9: 'sep',
            10: 'oct',
            11: 'nov',
            12: 'dec'
        };
        this.daysMap = {
            1: 'mo',
            2: 'tu',
            3: 'we',
            4: 'th',
            5: 'fr',
            6: 'sa',
            7: 'su'
        };
    }
    /**
     * If no key for the language used. Then we use English as default
     */
    getMonthShortName(month, year) {
        const key = 'dates.monthsShortName.' + this.monthsMap[month];
        const translatedValue = this.translate.instant(key);
        return (translatedValue === key) ? super.getMonthShortName(month) : translatedValue;
    }
    /**
     * If no key for the language used. Then we use English as default
     */
    getWeekdayLabel(weekday, width) {
        const key = 'dates.weekdayShortName.' + this.daysMap[weekday];
        const translatedValue = this.translate.instant(key);
        return (translatedValue === key) ? super.getWeekdayLabel(weekday, width) : translatedValue;
    }
}
DatepickerLanguage.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatepickerLanguage, deps: [{ token: i1$2.NgbCalendar }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
DatepickerLanguage.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatepickerLanguage });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatepickerLanguage, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.NgbCalendar }, { type: i2.TranslateService }]; } });

class DatepickerListComponent {
    get hostClasses() {
        return `border-list no-inner-borders`;
    }
    get getId() {
        return this.id;
    }
    get getTestId() {
        return this.dataTestId;
    }
    constructor(calender) {
        this.calender = calender;
        this.items = new Array();
        this.id = generateID();
        this.dataTestId = 'datepicker-list';
        this.disabled = false;
        this.propagateChange = (_) => { };
        this.onTouched = () => { };
    }
    writeValue(newItem) {
        this.selectedDate = newItem;
        let dateChoice;
        let dropdownChoice;
        for (const item of this.items) {
            if (this.isDateChoice(item)) {
                if (this.isSameDate(item.targetDate, this.selectedDate)) {
                    dateChoice = item;
                }
            }
            else if (this.isDateDropdown(item)) {
                dropdownChoice = item;
            }
        }
        if (dateChoice) {
            this.selectRadio(dateChoice);
        }
        else if (dropdownChoice && this.selectedDate) {
            this.selectRadio(dropdownChoice);
            this.dropdownSelection = this.selectedDate;
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    isDateChoice(choice) {
        const castChoice = choice;
        return consistsOf(castChoice, ['translationKey', 'targetDate']);
    }
    isDateDropdown(choice) {
        const castChoice = choice;
        return consistsOf(castChoice, ['dropdownTranslationKey']);
    }
    selectRadio(choice) {
        if (this.datePicker && this.isDateDropdown(choice)) {
            this.selectDatePickerOption();
        }
        else if (this.isDateChoice(choice)) {
            if (this.datePicker) {
                this.datePicker.close();
            }
            this.setValue(choice.targetDate);
            this.onTouched();
        }
    }
    selectDatePickerOption() {
        if (!this.disabled) {
            this.onTouched();
            if (this.dropdownSelection) {
                this.setValue(this.dropdownSelection);
            }
            this.datePicker.open();
        }
    }
    datepickerButtonClick() {
        this.datePicker.open();
        this.selectDatePickerOption();
    }
    setValue(date) {
        this.selectedDate = date;
        this.propagateChange(date);
    }
    isRadioChecked(choice) {
        if (this.isDateChoice(choice)) {
            return this.isSameDate(choice.targetDate, this.selectedDate);
        }
        else if (this.isDateDropdown(choice)) {
            return this.selectedDate !== undefined && this.selectedDate === this.dropdownSelection;
        }
        else
            return false;
    }
    selectDate(selectedDate) {
        this.dropdownSelection = selectedDate;
        this.setValue(selectedDate);
        this.datePicker.close();
    }
    isDateInList(date, current) {
        for (let i = 0; i < this.items.length; i++) {
            const dateChoice = this.items[i];
            if (this.isDateChoice(dateChoice)) {
                if (this.isSameDate(date, dateChoice.targetDate)) {
                    return true;
                }
            }
        }
        return false;
    }
    getDatePickerClass() {
        return this.id + "_datepicker";
    }
    isSameDate(date1, date2) {
        if (date1 === undefined || date2 === undefined || date1 === null || date2 === null) {
            return false;
        }
        return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
    }
}
DatepickerListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatepickerListComponent, deps: [{ token: i1$2.NgbCalendar }], target: i0.ɵɵFactoryTarget.Component });
DatepickerListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DatepickerListComponent, selector: "scu-datepicker-list", inputs: { items: "items", id: "id", dataTestId: "dataTestId", navigation: "navigation", minDate: "minDate", maxDate: "maxDate", displayMonths: "displayMonths", firstDayOfWeek: "firstDayOfWeek", autoClose: "autoClose", footerTemplate: "footerTemplate", outsideDays: "outsideDays", calendarButtonClasses: "calendarButtonClasses" }, host: { properties: { "class": "this.hostClasses", "attr.id": "this.getId", "attr.datatest": "this.getTestId" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerListComponent),
            multi: true
        },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        { provide: NgbDatepickerI18n, useClass: DatepickerLanguage }], viewQueries: [{ propertyName: "datePicker", first: true, predicate: ["datepicker"], descendants: true }], ngImport: i0, template: "<div *ngFor=\"let item of items; index as i\"\n     id=\"{{id+'_'+i}}\"\n     [attr.disabled]=\"disabled\"\n     class=\"form-check flex-value m-0 ps-1 cursor-pointer\">\n  <input [id]=\"id+'_'+i+'_radio'\"\n         class=\"form-check-input form-control p-0 m-3\"\n         type=\"radio\"\n         name=\"radioSelection\"\n         [attr.datatest]=\"dataTestId+'_'+i+'_radio'\"\n         (click)=\"selectRadio(item)\"\n         [checked]=\"isRadioChecked(item)\"\n         [disabled]=\"disabled\">\n  <ng-container *ngIf=\"isDateChoice(item)\">\n    <label class=\"form-check-label ps-1 text-18\" [for]=\"id+'_'+i+'_radio'\">\n      {{item.translationKey | translate}}\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"isDateDropdown(item)\">\n      <input class=\"text-18 form-check-label inherit-placeholder p-0 ps-1 datepicker-label\"\n             type=\"text\"\n             ngbDatepicker #datepicker=\"ngbDatepicker\"\n             placeholder=\"{{item.dropdownTranslationKey | translate}}\"\n             [id]=\"id+'_datepicker_input'\"\n             [attr.datatest]=\"dataTestId+'_datepicker'\"\n             (click)=\"selectDatePickerOption()\"\n             (dateSelect)=\"selectDate($event)\"\n             [disabled]=\"disabled\"\n             [datepickerClass]=\"getDatePickerClass()\"\n             [markDisabled]=\"isDateInList.bind(this)\"\n             [restoreFocus]=\"true\"\n             [displayMonths]=\"displayMonths\"\n             [minDate]=\"minDate\"\n             [maxDate]=\"maxDate\"\n             [navigation]=\"navigation\"\n             [firstDayOfWeek]=\"firstDayOfWeek\"\n             [autoClose]=\"autoClose\"\n             [footerTemplate]=\"footerTemplate\"\n             [outsideDays]=\"outsideDays\"\n             [(ngModel)]=\"dropdownSelection\"\n             readonly>\n      <button class=\"btn cursor-pointer datepicker-button calendar-icon disable-interactivity{{calendarButtonClasses ? ' '+calendarButtonClasses : '' }}\"\n              (click)=\"datepickerButtonClick()\"\n              [disabled]=\"disabled\"\n              [id]=\"id+'_datepicker_button'\"\n              [attr.datatest]=\"dataTestId+'_'+i+'_button'\">\n      </button>\n    </ng-container>\n  </div>\n", styles: [":host input.datepicker-label{background-image:none;padding:0 0 0 1.25rem}:host button.btn.datepicker-button{padding-left:1.25rem;padding-right:1.25rem;min-width:3.75rem;margin-left:auto;background-origin:content-box;background-repeat:no-repeat;background-position:center}:host button.btn.datepicker-button:disabled{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "popperOptions", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatepickerListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-datepicker-list', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DatepickerListComponent),
                            multi: true
                        },
                        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
                        { provide: NgbDatepickerI18n, useClass: DatepickerLanguage }], template: "<div *ngFor=\"let item of items; index as i\"\n     id=\"{{id+'_'+i}}\"\n     [attr.disabled]=\"disabled\"\n     class=\"form-check flex-value m-0 ps-1 cursor-pointer\">\n  <input [id]=\"id+'_'+i+'_radio'\"\n         class=\"form-check-input form-control p-0 m-3\"\n         type=\"radio\"\n         name=\"radioSelection\"\n         [attr.datatest]=\"dataTestId+'_'+i+'_radio'\"\n         (click)=\"selectRadio(item)\"\n         [checked]=\"isRadioChecked(item)\"\n         [disabled]=\"disabled\">\n  <ng-container *ngIf=\"isDateChoice(item)\">\n    <label class=\"form-check-label ps-1 text-18\" [for]=\"id+'_'+i+'_radio'\">\n      {{item.translationKey | translate}}\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"isDateDropdown(item)\">\n      <input class=\"text-18 form-check-label inherit-placeholder p-0 ps-1 datepicker-label\"\n             type=\"text\"\n             ngbDatepicker #datepicker=\"ngbDatepicker\"\n             placeholder=\"{{item.dropdownTranslationKey | translate}}\"\n             [id]=\"id+'_datepicker_input'\"\n             [attr.datatest]=\"dataTestId+'_datepicker'\"\n             (click)=\"selectDatePickerOption()\"\n             (dateSelect)=\"selectDate($event)\"\n             [disabled]=\"disabled\"\n             [datepickerClass]=\"getDatePickerClass()\"\n             [markDisabled]=\"isDateInList.bind(this)\"\n             [restoreFocus]=\"true\"\n             [displayMonths]=\"displayMonths\"\n             [minDate]=\"minDate\"\n             [maxDate]=\"maxDate\"\n             [navigation]=\"navigation\"\n             [firstDayOfWeek]=\"firstDayOfWeek\"\n             [autoClose]=\"autoClose\"\n             [footerTemplate]=\"footerTemplate\"\n             [outsideDays]=\"outsideDays\"\n             [(ngModel)]=\"dropdownSelection\"\n             readonly>\n      <button class=\"btn cursor-pointer datepicker-button calendar-icon disable-interactivity{{calendarButtonClasses ? ' '+calendarButtonClasses : '' }}\"\n              (click)=\"datepickerButtonClick()\"\n              [disabled]=\"disabled\"\n              [id]=\"id+'_datepicker_button'\"\n              [attr.datatest]=\"dataTestId+'_'+i+'_button'\">\n      </button>\n    </ng-container>\n  </div>\n", styles: [":host input.datepicker-label{background-image:none;padding:0 0 0 1.25rem}:host button.btn.datepicker-button{padding-left:1.25rem;padding-right:1.25rem;min-width:3.75rem;margin-left:auto;background-origin:content-box;background-repeat:no-repeat;background-position:center}:host button.btn.datepicker-button:disabled{background-color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbCalendar }]; }, propDecorators: { datePicker: [{
                type: ViewChild,
                args: ['datepicker']
            }], items: [{
                type: Input
            }], id: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], navigation: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], displayMonths: [{
                type: Input
            }], firstDayOfWeek: [{
                type: Input
            }], autoClose: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], outsideDays: [{
                type: Input
            }], calendarButtonClasses: [{
                type: Input
            }], hostClasses: [{
                type: HostBinding,
                args: ['class']
            }], getId: [{
                type: HostBinding,
                args: ['attr.id']
            }], getTestId: [{
                type: HostBinding,
                args: ['attr.datatest']
            }] } });

class InputFieldPlaceholderMaskComponent {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.dropSpecialCharacters = true;
        this.autocomplete = 'off';
        this.type = 'text';
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    writeValue(value) {
        if (this.formControlName) {
            this.childForm = new FormGroup({
                myInput: new FormControl(value, [Validators.required]),
            });
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnInit() {
        if (!this.formControlName) {
            throw new Error(`formControlName="yourInput" skal være angivet`);
        }
        if (!this.dataTest) {
            this.dataTest = `Input-fieldPlaceholderMask-${this.formControlName}`;
        }
    }
    onKeyUp(e) {
        this.onChange(this.childForm.getRawValue().myInput);
        this.ngControl.control.setErrors(this.childForm.valid ? null : { 'invalid': true });
    }
}
InputFieldPlaceholderMaskComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InputFieldPlaceholderMaskComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
InputFieldPlaceholderMaskComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: InputFieldPlaceholderMaskComponent, selector: "scu-input-field-placeholder-mask", inputs: { formControlName: "formControlName", mask: "mask", placeHolder: "placeHolder", patterns: "patterns", dropSpecialCharacters: "dropSpecialCharacters", dataTest: "dataTest", autocomplete: "autocomplete", type: "type" }, ngImport: i0, template: "<div [formGroup]=\"childForm\">\n  <input \n    [type]=\"type\"\n    formControlName=\"myInput\"\n    class=\"form-control text-16 sos-style\"\n    [dropSpecialCharacters]=\"dropSpecialCharacters\"\n    [mask]=\"mask ?? ''\"\n    [patterns]=\"patterns\"\n    [placeholder]=\"placeHolder ?? ''\"\n    [attr.data-test]=\"dataTest | createTestId\"\n    (keyup)=\"onKeyUp($event)\"\n    [autocomplete]=\"autocomplete\"    \n  >\n\n</div>\n", dependencies: [{ kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i2$1.MaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "triggerOnMaskChange"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InputFieldPlaceholderMaskComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-input-field-placeholder-mask', template: "<div [formGroup]=\"childForm\">\n  <input \n    [type]=\"type\"\n    formControlName=\"myInput\"\n    class=\"form-control text-16 sos-style\"\n    [dropSpecialCharacters]=\"dropSpecialCharacters\"\n    [mask]=\"mask ?? ''\"\n    [patterns]=\"patterns\"\n    [placeholder]=\"placeHolder ?? ''\"\n    [attr.data-test]=\"dataTest | createTestId\"\n    (keyup)=\"onKeyUp($event)\"\n    [autocomplete]=\"autocomplete\"    \n  >\n\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; }, propDecorators: { formControlName: [{
                type: Input
            }], mask: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], patterns: [{
                type: Input
            }], dropSpecialCharacters: [{
                type: Input
            }], dataTest: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

class Nationality {
    constructor(countryCode, phoneMask, phoneCode, ssnMask, ssnPlaceHolder, validatorPattern, domesticPhonePrefix = '') {
        this.countryCode = countryCode;
        this.phoneMask = phoneMask;
        this.phoneCode = phoneCode;
        this.ssnMask = ssnMask;
        this.ssnPlaceHolder = ssnPlaceHolder;
        this.validatorPattern = validatorPattern;
        this.domesticPhonePrefix = domesticPhonePrefix;
    }
    static byCountry(countryEnum) {
        return this.NATIONALITIES.find(n => n.countryCode === countryEnum);
    }
    static getCountrySSNValidator(nationality) {
        if (!Object.values(CountryEnum).includes(nationality.countryCode)) {
            throw new Error('Wrong nationality countryCode: ' + nationality.countryCode);
        }
        return this.NATIONALITIES.find(n => n.countryCode === nationality.countryCode).validatorPattern;
    }
    static getPhoneCodeFromCountry(countryCode) {
        const nationality = this.NATIONALITIES.find(element => {
            return element.countryCode === countryCode;
        });
        return (nationality) ? nationality.phoneCode : '';
    }
    static getCountryFromPhoneCode(phoneCode) {
        const nationality = this.NATIONALITIES.find(element => {
            return element.phoneCode === phoneCode;
        });
        return nationality.countryCode;
    }
}
Nationality.NATIONALITIES = [
    new Nationality(CountryEnum.DK, '00 00 00 00', '+45', '000000-0000', 'general.cprhint-DK', Validators.pattern('^[0-3][0-9][0-1][0-9]{3}[-][0-9]{4}$')),
    new Nationality(CountryEnum.NO, '000 00 000', '+47', '00000000000', 'general.cprhint-NO', Validators.pattern('^[0-34-7][0-9][0-14-5][0-9]{8}$')),
    new Nationality(CountryEnum.SE, '100 000 000', '+46', '000000T0000', 'general.cprhint-SE', Validators.pattern('^[0-9]{2}[0-1][0-9][0-36-9][0-9][-+][0-9]{4}$'), '0'),
    new Nationality(CountryEnum.FI, '00 000 0000', '+358', '000000T000A', 'general.cprhint-FI', Validators.pattern('^[0-3][0-9][0-1][0-9]{3}[-aA][0-9]{3}[0-9a-fA-FhHj-nJ-NpPr-yR-Y]'), '0'),
    new Nationality(CountryEnum.IS, '000 0000', '+354', '0000000000', 'general.cprhint-IS', Validators.pattern('^[0-3][0-9][0-1][0-9]{3}[0-9]{4}$'))
];

const customPatterns = {
    0: { pattern: new RegExp('\[0-9\]') },
    1: { pattern: new RegExp('\[1-9\]') },
    C: { pattern: new RegExp('\[a-zA-Z\]') },
    T: { pattern: new RegExp('\[aA+-\]') },
    A: { pattern: new RegExp('\[0-9a-zA-Z\]') }
};

/**
 * Check if a String Contains Only Uppercase Characters
 * @param str
 * @returns true if the string contains only uppercase characters
 */
function isAllUppercase(str) {
    return /^[A-Z]+$/.test(str);
}

class SelectFlagComponent {
    onSearch(searchValue, option) {
        searchValue = searchValue?.toLocaleLowerCase()?.trim();
        return option?.code?.toLocaleLowerCase()?.includes(searchValue) === true ||
            option?.text?.toLocaleLowerCase()?.includes(searchValue) === true ||
            option?.name?.toLocaleLowerCase()?.includes(searchValue) === true ||
            option?.flagAlpha2Code?.toLocaleLowerCase()?.includes(searchValue) === true;
    }
    constructor() {
        this.dataTest = 'SelectFlag';
        this.imgIconSizeCssClass = 'icon-l';
        this.translatePrefix = undefined;
        this.bindValue = 'code';
        this.isDropdownOpenForInput = false;
        this.form = new FormGroup({
            flagSelect: new FormControl()
        });
        this.onTouched = () => { };
        this.onChange = (selection) => { };
        this.selectedSimpleItem = [];
    }
    ngAfterViewInit() {
        this.form.get('flagSelect').valueChanges.subscribe((selection) => {
            this.onChange(this.allUppercase ? selection.toUpperCase() : selection);
            this.ngSelect.blur();
        });
    }
    findIndex(item) {
        return this.options.findIndex(s => s === item);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(obj) {
        // all flagAlpha2Code in lowercase in list - ellers kommer valgte flag ikke retur
        this.items = this.options.map(option => ({
            ...option,
            flagAlpha2Code: option.flagAlpha2Code.toLowerCase()
        }));
        this.allUppercase = isAllUppercase(obj);
        this.form.get('flagSelect').setValue(obj);
    }
}
SelectFlagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectFlagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SelectFlagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SelectFlagComponent, selector: "scu-select-flag", inputs: { options: "options", cssClass: "cssClass", dataTest: "dataTest", imgIconSizeCssClass: "imgIconSizeCssClass", translatePrefix: "translatePrefix", bindValue: "bindValue" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectFlagComponent),
            multi: true
        }
    ], viewQueries: [{ propertyName: "ngSelect", first: true, predicate: ["ngSelect"], descendants: true }], ngImport: i0, template: "<span [formGroup]=\"form\">\n  <ng-select class=\"sos-style flex-value h-em3 content-text-16 hide-cursor\"\n              #ngSelect\n              formControlName=\"flagSelect\"\n              [ngClass]=\"cssClass\"\n              [hideSelected]=\"false\"\n              [searchable]=\"true\"\n              [searchFn]=\"onSearch\"\n              [clearable]=\"false\"\n              [items]=\"items\"\n              bindLabel=\"text\" \n              [bindValue]=\"bindValue\" \n              [attr.data-test]=\"dataTest\"\n              (open)=\"isDropdownOpenForInput = true\"\n              (close)=\"isDropdownOpenForInput = false\"\n              (change)=\"isDropdownOpenForInput = false\"\n             >\n\n    <ng-template ng-label-tmp let-item=\"item\">\n      <span *ngIf=\"!isDropdownOpenForInput\" class=\"fi\" [class]=\"'fi-' + item.flagAlpha2Code?.toLowerCase()\" [ngClass]=\"imgIconSizeCssClass\"></span>\n      <span *ngIf=\"translatePrefix && !isDropdownOpenForInput\">{{translatePrefix + '.' + item.text | lowercase | translate}}</span>\n      <span *ngIf=\"translatePrefix === undefined && !isDropdownOpenForInput\">{{item.text}}</span>\n    </ng-template>\n\n    <ng-template ng-option-tmp let-item=\"item\">\n      <span class=\"fi\" [class]=\"'fi-' + item.flagAlpha2Code?.toLowerCase()\" [ngClass]=\"imgIconSizeCssClass\"></span>\n      <span *ngIf=\"translatePrefix\"\n            [attr.data-test]=\"dataTest | createTestId :findIndex(item)\">{{translatePrefix + '.' + item.text | lowercase | translate}}</span>\n      <span *ngIf=\"translatePrefix === undefined\"\n            [attr.data-test]=\"dataTest | createTestId :findIndex(item)\">{{item.text}}</span>\n    </ng-template>\n\n  </ng-select>\n</span>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i2$2.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "directive", type: i2$2.NgLabelTemplateDirective, selector: "[ng-label-tmp]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i1.LowerCasePipe, name: "lowercase" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectFlagComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-select-flag', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SelectFlagComponent),
                            multi: true
                        }
                    ], template: "<span [formGroup]=\"form\">\n  <ng-select class=\"sos-style flex-value h-em3 content-text-16 hide-cursor\"\n              #ngSelect\n              formControlName=\"flagSelect\"\n              [ngClass]=\"cssClass\"\n              [hideSelected]=\"false\"\n              [searchable]=\"true\"\n              [searchFn]=\"onSearch\"\n              [clearable]=\"false\"\n              [items]=\"items\"\n              bindLabel=\"text\" \n              [bindValue]=\"bindValue\" \n              [attr.data-test]=\"dataTest\"\n              (open)=\"isDropdownOpenForInput = true\"\n              (close)=\"isDropdownOpenForInput = false\"\n              (change)=\"isDropdownOpenForInput = false\"\n             >\n\n    <ng-template ng-label-tmp let-item=\"item\">\n      <span *ngIf=\"!isDropdownOpenForInput\" class=\"fi\" [class]=\"'fi-' + item.flagAlpha2Code?.toLowerCase()\" [ngClass]=\"imgIconSizeCssClass\"></span>\n      <span *ngIf=\"translatePrefix && !isDropdownOpenForInput\">{{translatePrefix + '.' + item.text | lowercase | translate}}</span>\n      <span *ngIf=\"translatePrefix === undefined && !isDropdownOpenForInput\">{{item.text}}</span>\n    </ng-template>\n\n    <ng-template ng-option-tmp let-item=\"item\">\n      <span class=\"fi\" [class]=\"'fi-' + item.flagAlpha2Code?.toLowerCase()\" [ngClass]=\"imgIconSizeCssClass\"></span>\n      <span *ngIf=\"translatePrefix\"\n            [attr.data-test]=\"dataTest | createTestId :findIndex(item)\">{{translatePrefix + '.' + item.text | lowercase | translate}}</span>\n      <span *ngIf=\"translatePrefix === undefined\"\n            [attr.data-test]=\"dataTest | createTestId :findIndex(item)\">{{item.text}}</span>\n    </ng-template>\n\n  </ng-select>\n</span>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { options: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], dataTest: [{
                type: Input
            }], imgIconSizeCssClass: [{
                type: Input
            }], translatePrefix: [{
                type: Input
            }], bindValue: [{
                type: Input
            }], ngSelect: [{
                type: ViewChild,
                args: ['ngSelect', { static: false }]
            }] } });

class PhoneNumberComponent {
    constructor(translate, maskService) {
        this.translate = translate;
        this.maskService = maskService;
        this.form = new FormGroup({
            prefix: new FormControl('', Validators.required),
            number: new FormControl(null, Validators.required),
            alpha2Code: new FormControl(null, Validators.required)
        });
        this.countryOptions = [];
        this.defaultCountryCode = CountryEnum.DK;
        this.phoneNumberPlaceholder = null;
        this.imgIconSizeCssClass = 'icon-xsm';
        this.onChange = (_) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        if (this.countries) {
            this.countries.forEach(country => {
                this.countryOptions.push({
                    flagAlpha2Code: country.alpha2Code.toLowerCase(),
                    text: country.phonePrefix,
                    code: country.alpha2Code,
                    name: country.name
                });
            });
        }
        else {
            throw new Error('countries[] is required!');
        }
    }
    onChangePrefix() {
        const result = this.countryOptions.find(country => country.flagAlpha2Code === this.form.get('alpha2Code').value);
        this.form.get('prefix').setValue(result.text);
        this.onClickMobileNationality();
    }
    onClickMobileNationality() {
        const phone = {
            prefix: this.form.get('prefix').value,
            number: this.maskService.applyMaskWithPattern(this.form.get('number').value, [this.getMask(), customPatterns]),
            alpha2Code: this.form.get('alpha2Code').value
        };
        phone.alpha2Code = this.allUppercase ? phone.alpha2Code.toUpperCase() : phone.alpha2Code;
        this.onChange(phone);
    }
    /*
    * Country prefix helper methods
    * */
    showPrefixForSelectedValue() {
        const country = this.findPrefixForCountry();
        return (country && country.domesticPhonePrefix.length > 0) ? true : false;
    }
    getTextForPrefix() {
        const country = this.findPrefixForCountry();
        return (country && country.domesticPhonePrefix) ? this.findPrefixForCountry().domesticPhonePrefix : '';
    }
    findPrefixForCountry() {
        return Nationality.NATIONALITIES.find((d) => d.countryCode === this.form.get('alpha2Code').value.toUpperCase());
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(obj) {
        this.allUppercase = isAllUppercase(obj.alpha2Code);
        if (obj) {
            if (!obj.alpha2Code)
                obj.alpha2Code = 'DK'; // dafault DK
            const result = this.countryOptions.find(country => country.flagAlpha2Code.toLowerCase() === obj.alpha2Code.toLowerCase());
            this.form.get('alpha2Code').setValue(result.flagAlpha2Code.toLowerCase());
            this.form.get('prefix').setValue(result.text);
            this.form.get('number').setValue(obj.number);
        }
    }
    validate(control) {
        this.form.updateValueAndValidity();
        if (control.hasValidator(Validators.required) && this.form.valid) {
            return null;
        }
        else if (control.hasValidator(Validators.required) && this.form.invalid) {
            return { valid: false };
        }
        else {
            return null;
        }
    }
    getMask() {
        const nationality = Nationality.byCountry(this.form.get('alpha2Code').value.toUpperCase()) || undefined;
        return (nationality) ? Nationality.byCountry(CountryEnum[nationality.countryCode]).phoneMask : '0*';
    }
}
PhoneNumberComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PhoneNumberComponent, deps: [{ token: i2.TranslateService }, { token: i2$1.MaskApplierService }], target: i0.ɵɵFactoryTarget.Component });
PhoneNumberComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PhoneNumberComponent, selector: "scu-phone-number", inputs: { countries: "countries", defaultCountryCode: "defaultCountryCode", errorMsg: "errorMsg", selectLabelText: "selectLabelText", headerText: "headerText", phoneNumberPlaceholder: "phoneNumberPlaceholder", imgIconSizeCssClass: "imgIconSizeCssClass" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneNumberComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PhoneNumberComponent),
            multi: true,
        }
    ], ngImport: i0, template: "<div class=\"d-flex w-100\" [formGroup]=\"form\">\n  <span class=\"d-flex flex-column pe-4 countryCode\">\n    <label class=\"text-18 pt-4 pb-2\"> {{\"general.phone-number.countryCode\" | translate}} </label>\n    <scu-select-flag\n      [options]=\"countryOptions\"\n      formControlName=\"alpha2Code\"\n      [imgIconSizeCssClass]=\"imgIconSizeCssClass\"\n      [cssClass]=\"'h-100'\"\n      (ngModelChange)=\"onChangePrefix()\"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  \n      class=\"flex-grow-1\"\n      bindValue=\"flagAlpha2Code\"\n      >\n    </scu-select-flag>\n  </span>\n  <span class=\"d-flex flex-column flex-grow-1 phoneNumber\" >\n    <label class=\"text-18 pt-4 pb-2\"> {{\"general.phone-number.phoneNumber\" | translate}} </label>\n    <div class=\"input-group flex-nowrap\">\n      <label *ngIf=\"showPrefixForSelectedValue()\" class=\"pe-2 input-group-text grey text-18\">\n        {{ getTextForPrefix() | translate}}\n      </label>\n      <scu-input-field-placeholder-mask\n        formControlName=\"number\"\n        [mask]=\"getMask()\"\n        [placeHolder]=\"phoneNumberPlaceholder  === null ? '' : phoneNumberPlaceholder\"\n        class=\"flex-fill\"\n        (change)=\"onClickMobileNationality()\"\n        (keyup)=\"onClickMobileNationality()\"\n        autocomplete=\"tel\"\n        type=\"tel\"\n        >\n      </scu-input-field-placeholder-mask>\n    </div>\n  </span>\n</div>\n<div *ngIf=\"!form.get('number').valid && (form.get('number').touched)\">\n  <p class=\"text-danger m-0\" >\n    {{errorMsg | translate}}\n  </p>\n</div>\n\n", styles: ["::ng-deep .input-group.flex-nowrap label:has(+ scu-input-field-placeholder-mask){margin-bottom:0}::ng-deep .input-group.flex-nowrap scu-input-field-placeholder-mask input{margin-bottom:0}.countryCode{min-width:140px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: InputFieldPlaceholderMaskComponent, selector: "scu-input-field-placeholder-mask", inputs: ["formControlName", "mask", "placeHolder", "patterns", "dropSpecialCharacters", "dataTest", "autocomplete", "type"] }, { kind: "component", type: SelectFlagComponent, selector: "scu-select-flag", inputs: ["options", "cssClass", "dataTest", "imgIconSizeCssClass", "translatePrefix", "bindValue"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PhoneNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-phone-number', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => PhoneNumberComponent),
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => PhoneNumberComponent),
                            multi: true,
                        }
                    ], template: "<div class=\"d-flex w-100\" [formGroup]=\"form\">\n  <span class=\"d-flex flex-column pe-4 countryCode\">\n    <label class=\"text-18 pt-4 pb-2\"> {{\"general.phone-number.countryCode\" | translate}} </label>\n    <scu-select-flag\n      [options]=\"countryOptions\"\n      formControlName=\"alpha2Code\"\n      [imgIconSizeCssClass]=\"imgIconSizeCssClass\"\n      [cssClass]=\"'h-100'\"\n      (ngModelChange)=\"onChangePrefix()\"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  \n      class=\"flex-grow-1\"\n      bindValue=\"flagAlpha2Code\"\n      >\n    </scu-select-flag>\n  </span>\n  <span class=\"d-flex flex-column flex-grow-1 phoneNumber\" >\n    <label class=\"text-18 pt-4 pb-2\"> {{\"general.phone-number.phoneNumber\" | translate}} </label>\n    <div class=\"input-group flex-nowrap\">\n      <label *ngIf=\"showPrefixForSelectedValue()\" class=\"pe-2 input-group-text grey text-18\">\n        {{ getTextForPrefix() | translate}}\n      </label>\n      <scu-input-field-placeholder-mask\n        formControlName=\"number\"\n        [mask]=\"getMask()\"\n        [placeHolder]=\"phoneNumberPlaceholder  === null ? '' : phoneNumberPlaceholder\"\n        class=\"flex-fill\"\n        (change)=\"onClickMobileNationality()\"\n        (keyup)=\"onClickMobileNationality()\"\n        autocomplete=\"tel\"\n        type=\"tel\"\n        >\n      </scu-input-field-placeholder-mask>\n    </div>\n  </span>\n</div>\n<div *ngIf=\"!form.get('number').valid && (form.get('number').touched)\">\n  <p class=\"text-danger m-0\" >\n    {{errorMsg | translate}}\n  </p>\n</div>\n\n", styles: ["::ng-deep .input-group.flex-nowrap label:has(+ scu-input-field-placeholder-mask){margin-bottom:0}::ng-deep .input-group.flex-nowrap scu-input-field-placeholder-mask input{margin-bottom:0}.countryCode{min-width:140px}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.TranslateService }, { type: i2$1.MaskApplierService }]; }, propDecorators: { countries: [{
                type: Input
            }], defaultCountryCode: [{
                type: Input
            }], errorMsg: [{
                type: Input
            }], selectLabelText: [{
                type: Input
            }], headerText: [{
                type: Input
            }], phoneNumberPlaceholder: [{
                type: Input
            }], imgIconSizeCssClass: [{
                type: Input
            }] } });

class ButtonComponent {
    constructor() {
        this.actionClick = new EventEmitter();
        this.cssClass = '';
        this.hidden = false;
    }
    ngOnInit() {
    }
    click() {
        this.actionClick.emit();
    }
}
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ButtonComponent, selector: "scu-button", inputs: { disabled: "disabled", text: "text", dataTestId: "dataTestId", cssClass: "cssClass", hidden: "hidden" }, outputs: { actionClick: "actionClick" }, ngImport: i0, template: "<button type=\"button\"\n        id=\"back\"\n        class=\"btn text-16\"\n        [ngClass]=\"cssClass\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [class.d-none]=\"hidden\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-button', template: "<button type=\"button\"\n        id=\"back\"\n        class=\"btn text-16\"\n        [ngClass]=\"cssClass\"\n        [disabled]=\"disabled\"\n        (click)=\"click()\"\n        [class.d-none]=\"hidden\"\n        [attr.data-test]=\"dataTestId\">\n  {{ text | translate }}\n</button>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { actionClick: [{
                type: Output
            }], disabled: [{
                type: Input
            }], text: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], hidden: [{
                type: Input
            }] } });

class SimpleFooterComponent {
    constructor() {
        this.buttonRight = new EventEmitter();
        this.buttonLeft = new EventEmitter();
        this.imageSource = '';
        this.textButtonLeft = 'navigation.back';
        this.textButtonRight = 'navigation.next';
        this.leftButtonCss = 'back-button';
        this.rightButtonCss = 'next-button-filled';
        this.hideLeftButton = true;
        this.hideButtons = false;
    }
    ngOnInit() {
    }
    leftButtonClick() {
        this.buttonLeft.emit();
    }
    rightButton() {
        this.buttonRight.emit();
    }
}
SimpleFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SimpleFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SimpleFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SimpleFooterComponent, selector: "scu-simple-footer", inputs: { imageSource: "imageSource", disabledLeft: "disabledLeft", disabledRight: "disabledRight", textButtonLeft: "textButtonLeft", textButtonRight: "textButtonRight", leftButtonCss: "leftButtonCss", rightButtonCss: "rightButtonCss", hideLeftButton: "hideLeftButton", hideButtons: "hideButtons" }, outputs: { buttonRight: "buttonRight", buttonLeft: "buttonLeft" }, ngImport: i0, template: "<div class=\"element-outlet\">\n  <ng-container>\n    <div class=\"d-flex justify-content-between simple-footer-padding\" *ngIf=\"!hideButtons\">\n      <div class=\"d-flex\">\n        <scu-button (actionClick)=\"leftButtonClick()\" [disabled]=\"disabledLeft\" [text]=\"textButtonLeft | translate\"\n                    [cssClass]=\"leftButtonCss\" [hidden]=\"hideLeftButton\">\n        </scu-button>\n      </div>\n      <div class=\"d-flex\">\n        <scu-button (actionClick)=\"rightButton()\" [disabled]=\"disabledRight\" [text]=\"textButtonRight | translate\"\n                    [cssClass]=\"rightButtonCss\">\n        </scu-button>\n      </div>\n    </div>\n    <div class=\"align-self-start ps-4\">\n      <span class=\"text-10\">{{'general.powered-by'| translate}} {{'general.sos-footer-brand' | translate}}</span>\n    </div>\n  </ng-container>\n</div>\n<div class=\"brand\"></div>\n", styles: [":host .simple-footer-padding{padding-top:1.25rem;padding-bottom:2.188rem}:host .brand{height:8px;background-color:rgb(var(--scu-primary))}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ButtonComponent, selector: "scu-button", inputs: ["disabled", "text", "dataTestId", "cssClass", "hidden"], outputs: ["actionClick"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SimpleFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-simple-footer', template: "<div class=\"element-outlet\">\n  <ng-container>\n    <div class=\"d-flex justify-content-between simple-footer-padding\" *ngIf=\"!hideButtons\">\n      <div class=\"d-flex\">\n        <scu-button (actionClick)=\"leftButtonClick()\" [disabled]=\"disabledLeft\" [text]=\"textButtonLeft | translate\"\n                    [cssClass]=\"leftButtonCss\" [hidden]=\"hideLeftButton\">\n        </scu-button>\n      </div>\n      <div class=\"d-flex\">\n        <scu-button (actionClick)=\"rightButton()\" [disabled]=\"disabledRight\" [text]=\"textButtonRight | translate\"\n                    [cssClass]=\"rightButtonCss\">\n        </scu-button>\n      </div>\n    </div>\n    <div class=\"align-self-start ps-4\">\n      <span class=\"text-10\">{{'general.powered-by'| translate}} {{'general.sos-footer-brand' | translate}}</span>\n    </div>\n  </ng-container>\n</div>\n<div class=\"brand\"></div>\n", styles: [":host .simple-footer-padding{padding-top:1.25rem;padding-bottom:2.188rem}:host .brand{height:8px;background-color:rgb(var(--scu-primary))}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { buttonRight: [{
                type: Output
            }], buttonLeft: [{
                type: Output
            }], imageSource: [{
                type: Input
            }], disabledLeft: [{
                type: Input
            }], disabledRight: [{
                type: Input
            }], textButtonLeft: [{
                type: Input
            }], textButtonRight: [{
                type: Input
            }], leftButtonCss: [{
                type: Input
            }], rightButtonCss: [{
                type: Input
            }], hideLeftButton: [{
                type: Input
            }], hideButtons: [{
                type: Input
            }] } });

/**
 * Replacement for CheckboxLabelComponent which is deprecated.
 */
class CheckboxLabelListComponent {
    constructor() {
        this.labelClasses = '';
        this.checkboxClasses = 'ms-1';
        this.wrapperClasses = '';
        this.dataTestId = 'checkbox-label';
        this.checkedItems = [];
        this.disabled = false;
        /* ControlValueAccessor */
        this.onChange = (_) => { };
        this.onTouched = () => { };
    }
    onChangeCheckbox(item) {
        // add or remove from checkedItems
        const itemIndex = this.checkedItems.findIndex(f => f === item);
        if (itemIndex !== -1) {
            this.checkedItems.splice(itemIndex, 1);
        }
        else {
            this.checkedItems.push(item);
        }
        this.onChange(this.checkedItems);
    }
    isChecked(item) {
        return this.checkedItems.some(f => f === item);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(defaultCheckedItems) {
        this.checkedItems = defaultCheckedItems ?? [];
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
CheckboxLabelListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckboxLabelListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CheckboxLabelListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CheckboxLabelListComponent, selector: "scu-checkbox-label-list", inputs: { items: "items", labelClasses: "labelClasses", checkboxClasses: "checkboxClasses", wrapperClasses: "wrapperClasses", dataTestId: "dataTestId" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxLabelListComponent),
            multi: true
        }], queries: [{ propertyName: "itemFormat", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<ng-container *ngFor=\"let item of items; index as i\">\n  <div class=\"form-check flex-value checkbox-spacing-class\" [ngClass]=\"wrapperClasses\">\n    <input [id]=\"item.id\"\n             class=\"form-check-input me-2\"\n             [ngClass]=\"checkboxClasses\"\n             type=\"checkbox\"\n             (change)=\"onChangeCheckbox(item.checkboxValue)\"\n             [checked]=\"isChecked(item.checkboxValue)\"\n             [disabled]=\"disabled\"\n             [attr.data-test]=\"dataTestId | createTestId :i\">\n    <label class=\"form-check-label ps-2\" [ngClass]=\"labelClasses\" [for]=\"item.id\">\n        <ng-container [ngTemplateOutlet]=\"itemFormat\" [ngTemplateOutletContext]=\"{$implicit: item, id: item.id, arrIndex: i}\"></ng-container>\n    </label>\n  </div>\n</ng-container>\n", styles: ["div.checkbox-spacing-class:nth-last-child(n+2),div.checkbox-spacing-class:nth-last-child(2)~.checkbox-spacing-class{padding:1rem}div.checkbox-spacing-class:only-child{padding:.25rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: TestDataPipe, name: "createTestId" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckboxLabelListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-checkbox-label-list', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => CheckboxLabelListComponent),
                            multi: true
                        }], template: "<ng-container *ngFor=\"let item of items; index as i\">\n  <div class=\"form-check flex-value checkbox-spacing-class\" [ngClass]=\"wrapperClasses\">\n    <input [id]=\"item.id\"\n             class=\"form-check-input me-2\"\n             [ngClass]=\"checkboxClasses\"\n             type=\"checkbox\"\n             (change)=\"onChangeCheckbox(item.checkboxValue)\"\n             [checked]=\"isChecked(item.checkboxValue)\"\n             [disabled]=\"disabled\"\n             [attr.data-test]=\"dataTestId | createTestId :i\">\n    <label class=\"form-check-label ps-2\" [ngClass]=\"labelClasses\" [for]=\"item.id\">\n        <ng-container [ngTemplateOutlet]=\"itemFormat\" [ngTemplateOutletContext]=\"{$implicit: item, id: item.id, arrIndex: i}\"></ng-container>\n    </label>\n  </div>\n</ng-container>\n", styles: ["div.checkbox-spacing-class:nth-last-child(n+2),div.checkbox-spacing-class:nth-last-child(2)~.checkbox-spacing-class{padding:1rem}div.checkbox-spacing-class:only-child{padding:.25rem}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { items: [{
                type: Input
            }], itemFormat: [{
                type: ContentChild,
                args: [TemplateRef]
            }], labelClasses: [{
                type: Input
            }], checkboxClasses: [{
                type: Input
            }], wrapperClasses: [{
                type: Input
            }], dataTestId: [{
                type: Input
            }] } });

var SCUColor;
(function (SCUColor) {
    SCUColor["PRIMARY"] = "primary";
    SCUColor["PRIMARY_DARK"] = "primary-dark";
    SCUColor["PRIMARY_FADED"] = "primary-faded";
    SCUColor["PRIMARY_LIGHT"] = "primary-light";
    SCUColor["SECONDARY"] = "secondary";
    SCUColor["SECONDARY_DARK"] = "secondary-dark";
    SCUColor["SECONDARY_FADED"] = "secondary-faded";
    SCUColor["SECONDARY_LIGHT"] = "secondary-light";
    SCUColor["TERTIARY"] = "tertiary";
    SCUColor["TERTIARY_DARK"] = "tertiary-dark";
    SCUColor["TERTIARY_FADED"] = "tertiary-faded";
    SCUColor["TERTIARY_LIGHT"] = "tertiary-light";
    SCUColor["BACKDROP"] = "backdrop";
    SCUColor["BACKDROP_DARK"] = "backdrop-dark";
    SCUColor["BACKDROP_FADED"] = "backdrop-faded";
    SCUColor["BACKDROP_LIGHT"] = "backdrop-light";
    SCUColor["SOS_RED"] = "sos-red";
})(SCUColor || (SCUColor = {}));

class DocumentService {
    setPropertyValue(name, value) {
        document.documentElement.style.setProperty(name, value);
    }
    getPropertyValue(name) {
        if (!this.computedStyle) {
            this.computedStyle = getComputedStyle(document.documentElement);
        }
        return this.computedStyle.getPropertyValue(name);
    }
    getDocument() {
        return document;
    }
    getComputedStyle() {
        if (!this.computedStyle) {
            this.computedStyle = getComputedStyle(document.documentElement);
        }
        return this.computedStyle;
    }
}
DocumentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DocumentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CssService {
    constructor(config, documentService) {
        this.config = config;
        this.documentService = documentService;
        this.defaultColors = {};
        this.classVarMap = this.getCssClassToVariableMap();
        this.prefix = this.getPrefix();
        console.info("Starting css service with config", config?.colorTheme);
        this.classBuilders = new Array();
        this.setDefaultColors(config.colorTheme);
        this.generateCheckClasses();
        this.generateRadioClasses();
        this.generateCalendarIconClasses();
        this.generateChevronClasses();
        this.generateCurrentLocationIconClasses();
        this.generateSearchCrossIconClasses();
    }
    generateClasses() {
        this.wipeRules();
        for (const classBuilderFunction of this.classBuilders) {
            classBuilderFunction(this.addClass.bind(this), this.getEncodedHexColor.bind(this), this.classVarMap, this.documentService.getComputedStyle());
        }
    }
    resetToDefaultColors() {
        for (const color in this.defaultColors) {
            const colorName = this.classVarMap.get(this.getPrefix() + SCUColor[color]);
            const colorValue = this.defaultColors[color];
            this.documentService.setPropertyValue(colorName, colorValue);
        }
        this.generateClasses();
    }
    overrideDefaultColorByName(name, value) {
        if (Object.keys(SCUColor).includes(name)) {
            this.defaultColors[name] = this.hexToRgb(value);
        }
        else {
            const colorByValue = this.getSCUColorByValue(name);
            if (colorByValue) {
                this.defaultColors[colorByValue] = this.hexToRgb(value);
            }
            else {
                console.warn("overrideDefaultColorByName called with unexpected parameter", name, value);
            }
        }
    }
    setColors(changes) {
        changes(this.byEnum.bind(this), this.byName.bind(this));
        this.generateClasses();
    }
    byEnum(name, value) {
        this.documentService.setPropertyValue(this.classVarMap.get(this.getPrefix() + name), this.hexToRgb(value));
    }
    byName(name, value) {
        if (Object.keys(SCUColor).includes(name)) {
            this.documentService.setPropertyValue(this.classVarMap.get(this.getPrefix() + name), this.hexToRgb(value));
        }
        else {
            console.warn("byName called with unexpected parameter", name, value);
        }
    }
    wipeRules() {
        if (this.styleElement) {
            for (let i = this.cssStyleSheet.cssRules.length - 1; i >= 0; i--) {
                this.cssStyleSheet.deleteRule(i);
            }
            this.documentService.getDocument().head.removeChild(this.styleElement);
        }
        this.styleElement = this.documentService.getDocument().createElement("style");
        this.styleElement.toggleAttribute("scu");
        this.documentService.getDocument().head.appendChild(this.styleElement);
        this.cssStyleSheet = this.styleElement.sheet;
    }
    setDefaultColors(overrides) {
        for (const color in SCUColor) {
            const scuName = SCUColor[color];
            if (overrides && overrides[scuName]) {
                this.defaultColors[color] = this.hexToRgb(overrides[scuName]);
            }
            else {
                const propertyValue = this.documentService.getPropertyValue(this.classVarMap.get(this.getPrefix() + SCUColor[color]));
                if (propertyValue) {
                    this.defaultColors[color] = propertyValue.trim();
                }
            }
        }
    }
    generateCheckClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('.form-check.sos-style .form-check-input[type=checkbox]:not(:disabled, .disabled, [disabled]):checked,' +
                '.sos-style .form-check .form-check-input[type=checkbox]:not(:disabled, .disabled, [disabled]):checked' +
                ' {' +
                'background-image: ' + this.getCheckboxImage(getColor(SCUColor.BACKDROP_LIGHT)) +
                '}');
            addClass('.form-check.sos-style .form-check-input[type=checkbox]:is(:disabled, .disabled, [disabled]):checked,' +
                '.sos-style .form-check .form-check-input[type=checkbox]:is(:disabled, .disabled, [disabled]):checked' +
                ' {' +
                'background-image: ' + this.getCheckboxImage(getColor(SCUColor.SECONDARY)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('.form-check.sos-style .form-check-input[type=checkbox].' + cssClass + ':not(:disabled, .disabled, [disabled]):checked,' +
                    '.sos-style .form-check .form-check-input[type=checkbox].' + cssClass + ':not(:disabled, .disabled, [disabled]):checked {' +
                    'background-image: ' + this.getCheckboxImage(getColor(cssClass)) +
                    '}');
                addClass('.form-check.sos-style .form-check-input[type=checkbox].' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]):checked,' +
                    '.sos-style .form-check .form-check-input[type=checkbox].' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]):checked {' +
                    'background-image: ' + this.getCheckboxImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    generateRadioClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('.form-check.sos-style .form-check-input[type=radio]:not(:disabled, .disabled, [disabled]):checked,' +
                '.sos-style .form-check .form-check-input[type=radio]:not(:disabled, .disabled, [disabled]):checked' +
                ' {' +
                'background-image: ' + this.getRadioImage(getColor(SCUColor.BACKDROP_LIGHT)) +
                '}');
            addClass('.form-check.sos-style .form-check-input[type=radio]:is(:disabled, .disabled, [disabled]):checked,' +
                '.sos-style .form-check .form-check-input[type=radio]:is(:disabled, .disabled, [disabled]):checked' +
                ' {' +
                'background-image: ' + this.getRadioImage(getColor(SCUColor.SECONDARY)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('.form-check.sos-style .form-check-input[type=radio].' + cssClass + ':not(:disabled, .disabled, [disabled]):checked,' +
                    '.sos-style .form-check .form-check-input[type=radio].' + cssClass + ':not(:disabled, .disabled, [disabled]):checked {' +
                    'background-image: ' + this.getRadioImage(getColor(cssClass)) +
                    '}');
                addClass('.form-check.sos-style .form-check-input[type=radio].' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]):checked,' +
                    '.sos-style .form-check .form-check-input[type=radio].' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]):checked {' +
                    'background-image: ' + this.getRadioImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    generateCalendarIconClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('input[ngbdatepicker].sos-style.calendar-icon:not(:disabled, .disabled, [disabled]),' +
                '.sos-style input[ngbdatepicker].calendar-icon:not(:disabled, .disabled, [disabled]),' +
                'button.sos-style.calendar-icon:not(:disabled, .disabled, [disabled]),' +
                '.sos-style button.calendar-icon:not(:disabled, .disabled, [disabled]),' +
                'button.sos-style.calendar-button:not(:disabled, .disabled, [disabled]),' +
                '.sos-style button.calendar-button:not(:disabled, .disabled, [disabled])' +
                ' {' +
                'background-image: ' + this.getCalendarImage(getColor(SCUColor.SECONDARY_DARK)) +
                '}');
            addClass('input[ngbdatepicker].sos-style.calendar-icon:is(:disabled, .disabled, [disabled]),' +
                '.sos-style input[ngbdatepicker].calendar-icon:is(:disabled, .disabled, [disabled]),' +
                'button.sos-style.calendar-icon:is(:disabled, .disabled, [disabled]),' +
                '.sos-style button.calendar-icon:is(:disabled, .disabled, [disabled]),' +
                'button.sos-style.calendar-button:is(:disabled, .disabled, [disabled]),' +
                '.sos-style button.calendar-button:is(:disabled, .disabled, [disabled])' +
                ' {' +
                'background-image: ' + this.getCalendarImage(getColor(SCUColor.SECONDARY_FADED)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('input[ngbdatepicker].sos-style.calendar-icon.icon-' + cssClass + ':not(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].calendar-icon.icon-' + cssClass + ':not(:disabled, .disabled, [disabled]),' +
                    'button.sos-style.calendar-icon.icon-' + cssClass + ':not(:disabled, .disabled, [disabled]),' +
                    '.sos-style button.calendar-icon.icon-' + cssClass + ':not(:disabled, .disabled, [disabled])' +
                    ' {' +
                    'background-image: ' + this.getCalendarImage(getColor(cssClass)) +
                    '}');
                addClass('input[ngbdatepicker].sos-style.calendar-icon.icon-' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].calendar-icon.icon-' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]),' +
                    'button.sos-style.calendar-icon.icon-' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style button.calendar-icon.icon-' + cssClass + '-disabled:is(:disabled, .disabled, [disabled])' +
                    ' {' +
                    'background-image: ' + this.getCalendarImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    generateChevronClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('ngb-datepicker.sos-style .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                '.sos-style ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled])' +
                '{' +
                'background-image: ' + this.getChevronLeftImage(getColor(SCUColor.PRIMARY)) +
                '}');
            addClass('ngb-datepicker.sos-style .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                '.sos-style ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled])' +
                '{' +
                'background-image: ' + this.getChevronRightImage(getColor(SCUColor.PRIMARY)) +
                '}');
            addClass('ngb-datepicker.sos-style .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                '.sos-style ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled])' +
                '{' +
                'background-image: ' + this.getChevronLeftImage(getColor(SCUColor.SECONDARY)) +
                '}');
            addClass('ngb-datepicker.sos-style .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                '.sos-style ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled])' +
                '{' +
                'background-image: ' + this.getChevronRightImage(getColor(SCUColor.SECONDARY)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('ngb-datepicker.chevron-' + cssClass + '.sos-style .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    '.sos-style ngb-datepicker.chevron-' + cssClass + ' .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    'input[ngbdatepicker].sos-style.chevron-' + cssClass + ' + ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].chevron-' + cssClass + ' + ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled])' +
                    '{' +
                    'background-image: ' + this.getChevronLeftImage(getColor(cssClass)) +
                    '}');
                addClass('ngb-datepicker.chevron-' + cssClass + '.sos-style .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    '.sos-style ngb-datepicker.chevron-' + cssClass + ' .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    'input[ngbdatepicker].sos-style.chevron-' + cssClass + ' + ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].chevron-' + cssClass + ' + ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:not(:disabled, .disabled, [disabled])' +
                    '{' +
                    'background-image: ' + this.getChevronRightImage(getColor(cssClass)) +
                    '}');
                addClass('ngb-datepicker.chevron-' + cssClass + '-disabled.sos-style .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style ngb-datepicker.chevron-' + cssClass + '-disabled .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    'input[ngbdatepicker].sos-style.chevron-' + cssClass + '-disabled + ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].chevron-' + cssClass + '-disabled + ngb-datepicker .ngb-dp-arrow .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled])' +
                    '{' +
                    'background-image: ' + this.getChevronLeftImage(getColor(cssClass)) +
                    '}');
                addClass('ngb-datepicker.chevron-' + cssClass + '-disabled.sos-style .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style ngb-datepicker.chevron-' + cssClass + '-disabled .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    'input[ngbdatepicker].sos-style.chevron-' + cssClass + '-disabled + ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled]),' +
                    '.sos-style input[ngbdatepicker].chevron-' + cssClass + '-disabled + ngb-datepicker .ngb-dp-arrow.right .ngb-dp-navigation-chevron:is(:disabled, .disabled, [disabled])' +
                    '{' +
                    'background-image: ' + this.getChevronRightImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    generateCurrentLocationIconClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('.sos-style .current-location-icon:not(:disabled, .disabled, [disabled]),' +
                '.current-location-icon.sos-style:not(:disabled, .disabled, [disabled])' +
                ' {' +
                'background-image: ' + this.getCurrentLocationImage(getColor(SCUColor.PRIMARY)) +
                '}');
            addClass('.sos-style .current-location-icon:is(:disabled, .disabled, [disabled]),' +
                '.current-location-icon.sos-style:is(:disabled, .disabled, [disabled])' +
                ' {' +
                'background-image: ' + this.getCurrentLocationImage(getColor(SCUColor.SECONDARY)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('.sos-style .current-location-icon.icon-' + cssClass + ':not(:disabled, .disabled, [disabled]),' +
                    '.current-location-icon.icon-' + cssClass + '.sos-style:not(:disabled, .disabled, [disabled])' +
                    ' {' +
                    'background-image: ' + this.getCurrentLocationImage(getColor(cssClass)) +
                    '}');
                addClass('.sos-style .current-location-icon.icon-' + cssClass + '-disabled:is(:disabled, .disabled, [disabled]),' +
                    '.current-location-icon.icon-' + cssClass + '-disabled.sos-style:is(:disabled, .disabled, [disabled])' +
                    ' {' +
                    'background-image: ' + this.getCurrentLocationImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    generateSearchCrossIconClasses() {
        this.addClasses((addClass, getColor, classVarMap) => {
            addClass('input.sos-style::-webkit-search-cancel-button, ' +
                '.sos-style input::-webkit-search-cancel-button' +
                ' {' +
                'background-image: ' + this.getCrossImage(getColor(SCUColor.PRIMARY)) +
                '}');
            for (const cssClass of classVarMap.keys()) {
                addClass('input.sos-style.icon-' + cssClass + '::-webkit-search-cancel-button,' +
                    '.sos-style input.icon-' + cssClass + '::-webkit-search-cancel-button' +
                    ' {' +
                    'background-image: ' + this.getCrossImage(getColor(cssClass)) +
                    '}');
            }
        });
    }
    getRadioImage(fillHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'-4 -4 8 8\'%3E%3Ccircle r=\'2\' fill=\'' + fillHexColor + '\'/%3E%3C/svg%3E")';
    }
    getCalendarImage(fillHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'20\' height=\'20\' viewBox=\'0 0 20 20\'%3E%3Cpath id=\'calendar-clear\' d=\'M52,36.287a2.857,2.857,0,0,0-2.857-2.857h-.714v-.694a.728.728,0,0,0-.68-.733.714.714,0,0,0-.749.713v.714H37v-.694A.728.728,0,0,0,36.32,32a.714.714,0,0,0-.749.713v.714h-.714A2.857,2.857,0,0,0,32,36.287v.536a.179.179,0,0,0,.179.179H51.821A.179.179,0,0,0,52,36.823ZM32,49.144A2.857,2.857,0,0,0,34.857,52H49.143A2.857,2.857,0,0,0,52,49.144V38.609a.179.179,0,0,0-.179-.179H32.179a.179.179,0,0,0-.179.179Z\' transform=\'translate(-32 -32.001)\' fill=\'' + fillHexColor + '\'/%3E%3C/svg%3E%0A")';
    }
    getChevronLeftImage(strokeHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' class=\'ionicon\' viewBox=\'0 0 512 512\'%3E%3Ctitle%3EChevron Back%3C/title%3E%3Cpath fill=\'none\' stroke=\'' + strokeHexColor + '\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'48\' d=\'M328 112L184 256l144 144\' /%3E%3C/svg%3E")';
    }
    getChevronRightImage(strokeHexColor) {
        return 'url("data:image/svg+xml,%3Csvg width=\'100%25\' height=\'100%25\' viewBox=\'0 0 512 512\' version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' xml:space=\'preserve\' style=\'fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;\'%3E%3Cg transform=\'matrix(-1,0.000788226,-0.000788226,-1,512.202,511.798)\'%3E%3Cpath d=\'M328,112L184,256L328,400\' style=\'fill:none;fill-rule:nonzero;stroke:' + strokeHexColor + ';stroke-width:48px;\'/%3E%3C/g%3E%3C/svg%3E")';
    }
    getCurrentLocationImage(strokeHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'36.501\' height=\'36.501\' viewBox=\'0 0 36.501 36.501\'%3E%3Cg id=\'Red\' transform=\'translate(-6.666 -6.832)\'%3E%3Cpath id=\'Path_2863\' data-name=\'Path 2863\' d=\'M160.812,160.1l-16.273,7.184a.947.947,0,0,0,.4,1.8h7.782a.349.349,0,0,1,.349.349v7.78a.953.953,0,0,0,1.813.4l7.173-16.272a.936.936,0,0,0-1.242-1.242Z\' transform=\'translate(-128.85 -143.303)\' fill=\'' + strokeHexColor + '\'/%3E%3Cpath id=\'Path_2864\' data-name=\'Path 2864\' d=\'M97.5,80.75A16.75,16.75,0,1,0,80.75,97.5,16.755,16.755,0,0,0,97.5,80.75Z\' transform=\'translate(-55.834 -55.668)\' fill=\'none\' stroke=\'' + strokeHexColor + '\' stroke-miterlimit=\'10\' stroke-width=\'3\'/%3E%3C/g%3E%3C/svg%3E%0A")';
    }
    getCheckboxImage(fillHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16.259\' height=\'14.126\' viewBox=\'0 0 16.259 14.126\'%3E%3Cpath id=\'Path_4\' data-name=\'Path 4\' d=\'M6547.185,2726.5l1.056,1.194-3.473,3.96-6.616,7.465-4.836-5.457.125-.141.843-.951,3.747,4.228Z\' transform=\'translate(-6532.648 -2725.745)\' fill=\'' + fillHexColor + '\' stroke=\'' + fillHexColor + '\' stroke-width=\'1\'/%3E%3C/svg%3E")';
    }
    getCrossImage(fillHexColor) {
        return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'' + fillHexColor + '\'%3E%3Cpath d=\'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\'/%3E%3C/svg%3E")';
    }
    addClasses(change) {
        this.classBuilders.push(change);
    }
    addClass(rule) {
        this.cssStyleSheet.insertRule(rule, this.cssStyleSheet.cssRules.length);
    }
    getEncodedHexColor(varName) {
        let colorName = varName;
        if (!colorName.startsWith(this.prefix)) {
            colorName = this.prefix + colorName;
        }
        const cssVariable = this.documentService.getPropertyValue(this.classVarMap.get(colorName));
        return cssVariable ? this.rgbStringToHex(cssVariable.trim()).replace('#', '%23') : undefined;
    }
    getPrefix() {
        return 'scu-';
    }
    getCssNames() {
        return Object.values(SCUColor);
    }
    getCssVariables() {
        const prefix = this.getPrefix();
        const colors = this.getCssNames();
        const variables = new Array();
        for (const color of colors) {
            variables.push('--' + prefix + color);
        }
        return variables;
    }
    getCssClassToVariableMap() {
        const prefix = this.getPrefix();
        const classes = this.getCssNames();
        const classVarMap = new Map();
        for (const colorClass of classes) {
            classVarMap.set(prefix + colorClass, '--' + prefix + colorClass);
        }
        return classVarMap;
    }
    componentToHex(c) {
        let hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    rgbStringToHex(input) {
        const inputArray = input.split(',');
        if (inputArray.length === 3) {
            return this.rgbToHex(Number(inputArray[0].trim()), Number(inputArray[1].trim()), Number(inputArray[2].trim()));
        }
        else {
            return undefined;
        }
    }
    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }
    hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : '';
    }
    getSCUColorByValue(value) {
        // @ts-ignore
        const keyIndex = Object.values(SCUColor).indexOf(value);
        return Object.keys(SCUColor)[keyIndex];
    }
}
CssService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CssService, deps: [{ token: SOSCommonUIConfig }, { token: DocumentService }], target: i0.ɵɵFactoryTarget.Injectable });
CssService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CssService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CssService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: SOSCommonUIConfig }, { type: DocumentService }]; } });

class BrandingService {
    constructor(http, cssService, configuration) {
        this.http = http;
        this.cssService = cssService;
        this.configuration = configuration;
    }
    getBrandingColors() {
        return new Promise((resolve, reject) => {
            if (this.configuration && this.configuration.enableCoBranding) {
                this.http.get('/branding', { responseType: "json" }).subscribe({ next: brandingResult => {
                        for (const colorValue of brandingResult.brandingColors) {
                            this.cssService.overrideDefaultColorByName(colorValue.color, colorValue.value);
                        }
                        resolve();
                    }, error: (err) => { reject(err); } });
            }
            else {
                resolve();
            }
        });
    }
}
BrandingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BrandingService, deps: [{ token: i1$3.HttpClient }, { token: CssService }, { token: SOSCommonUIConfig }], target: i0.ɵɵFactoryTarget.Injectable });
BrandingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BrandingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BrandingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: CssService }, { type: SOSCommonUIConfig }]; } });

class DatePickerComponent {
    constructor(control, fb, translateService) {
        this.control = control;
        this.fb = fb;
        this.translateService = translateService;
        this.datepickerClass = 'sos-style';
        this.id = this.formControlName;
        this.placeholder = '';
        this.applyBorder = false;
        this.markDisabled = (Date) => { return false; };
        this.navigation = 'select';
        this.outsideDays = 'visible';
        this.showWeekNumbers = false;
        this.autoClose = true;
        /**
         * add a clear button if date selected with hover text
         */
        this.clearDateAllowed = false;
        this.clearDateHoverText = 'Clear date';
        this.dataTestPrefix = '';
        this.dateSelect = new EventEmitter();
        this.reset = new EventEmitter();
        this.datePickerForm = this.fb.group({
            date: ['']
        });
        this.control.valueAccessor = this;
    }
    ngOnInit() {
        this.data_test = (this.dataTestPrefix) ?
            `${this.dataTestPrefix}-${this.camelToHyphenCase(this.formControlName)}`
            : this.camelToHyphenCase(this.formControlName);
    }
    ngOnDestroy() { }
    onBlur() {
        this.onTouched();
    }
    writeValue(value) {
        this.datePickerForm = this.fb.group({
            date: (value.year && value.month && value.day) ? [value] : ['']
        });
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onDateSelected() {
        this.onChange(this.datePickerForm.controls['date'].value);
        if (this.dateSelect.observed) {
            this.dateSelect.emit(this.datePickerForm.controls['date'].value);
        }
    }
    clearSelectedDate(fn) {
        this.datePickerForm.patchValue({
            date: ''
        });
        fn.toggle();
        this.onDateSelected();
        if (this.reset.observed) {
            this.reset.emit(this.formControlName);
        }
    }
    /**
    * e.g. "myOwnString" will be returned as "my-own-string"
    * @param camel string data holding a camel case string to be converted
    * @returns returning string holding the input as hyphen string
    */
    camelToHyphenCase(camel) {
        return camel.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
    }
}
DatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatePickerComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i1$4.FormBuilder }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
DatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DatePickerComponent, selector: "scu-datepicker", inputs: { formControlName: "formControlName", body: "body", datepickerClass: "datepickerClass", label: "label", id: "id", placeholder: "placeholder", minDate: "minDate", maxDate: "maxDate", applyBorder: "applyBorder", displayMonths: "displayMonths", firstDayOfWeek: "firstDayOfWeek", markDisabled: "markDisabled", navigation: "navigation", outsideDays: "outsideDays", showWeekNumbers: "showWeekNumbers", startDate: "startDate", autoClose: "autoClose", dayTemplate: "dayTemplate", dayTemplateData: "dayTemplateData", placement: "placement", restoreFocus: "restoreFocus", weekdays: "weekdays", clearDateAllowed: "clearDateAllowed", clearDateHoverText: "clearDateHoverText", dataTestPrefix: "dataTestPrefix" }, outputs: { dateSelect: "dateSelect", reset: "reset" }, ngImport: i0, template: "<label *ngIf=\"label\" class=\"form-label\"> {{ label }}</label>\n<form [formGroup]=\"datePickerForm\">\n  <div  class=\"input-group\" [class.border-invalid] = applyBorder>\n    <input\n      [container]=\"body\"\n      class=\"form-control inputDate shadow-none\"\n      [datepickerClass]=\"datepickerClass\"\n      [name]=\"formControlName\"\n      ngbDatepicker\n      #datePicker=\"ngbDatepicker\"\n      readonly\n      formControlName=\"date\"\n      [placeholder]=\"placeholder\"\n      (click)=\"datePicker.toggle()\"\n      [footerTemplate]=\"footerTemplate\"\n      (dateSelect)=\"onDateSelected()\"\n      [minDate]=\"minDate\"\n      [maxDate]=\"maxDate\"\n      (blur)=\"onBlur()\"\n      [displayMonths]=\"displayMonths\"\n      [firstDayOfWeek]=\"firstDayOfWeek\"\n      [markDisabled]=\"markDisabled\"\n      [navigation]=\"navigation\"\n      [outsideDays]=\"outsideDays\"\n      [autoClose]=\"autoClose\"\n      [dayTemplate]=\"dayTemplate\"\n      [dayTemplateData]=\"dayTemplateData\"\n      [restoreFocus]=\"restoreFocus\"\n      [weekdays]=\"weekdays\"\n      [attr.data-test]=\"'datepicker-' + data_test\"\n      >\n    <ng-template #footerTemplate>\n      <div *ngIf=\"this.datePickerForm.controls['date'].value && clearDateAllowed\">\n        <hr class=\"my-0\" />\n        <img\n          src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy4xMjEiIGhlaWdodD0iMTcuMTIxIiB2aWV3Qm94PSIwIDAgMTcuMTIxIDE3LjEyMSI+CjxnIGlkPSJLcnlkcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3OTAuNDM5IC0xMDA0LjQzOSkiPgo8bGluZSBpZD0iTGluZV80NiIgZGF0YS1uYW1lPSJMaW5lIDQ2IiB4Mj0iMTUiIHkyPSIxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDc5MS41IDEwMDUuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Y1MGEzNyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxsaW5lIGlkPSJMaW5lXzQ3IiBkYXRhLW5hbWU9IkxpbmUgNDciIHkxPSIxNSIgeDI9IjE1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NzkxLjUgMTAwNS41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZjUwYTM3IiBzdHJva2Utd2lkdGg9IjMiLz4KPC9nPgo8L3N2Zz4=\"\n          width=\"15%\"\n          (click)=\"clearSelectedDate(datePicker)\"\n          class=\"btn m-1 float-end\"\n          [ngbTooltip]=\"clearDateHoverText\"\n          />\n      </div>\n    </ng-template>\n  </div>\n</form>\n", styles: [".form-control[ngbdatepicker]{background-image:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 class%3D%22ionicon%22 viewBox%3D%220 0 512 512%22%3E%3Ctitle%3ECalendar Clear%3C%2Ftitle%3E%3Cpath d%3D%22M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4H36a4 4 0 00-4 4z%22%2F%3E%3C%2Fsvg%3E\");background-origin:content-box;background-repeat:no-repeat;background-position:right;background-size:22px;cursor:pointer}.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:.313rem;border-bottom-right-radius:.313rem}.form-control{border-radius:.313rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "popperOptions", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { kind: "directive", type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-datepicker', template: "<label *ngIf=\"label\" class=\"form-label\"> {{ label }}</label>\n<form [formGroup]=\"datePickerForm\">\n  <div  class=\"input-group\" [class.border-invalid] = applyBorder>\n    <input\n      [container]=\"body\"\n      class=\"form-control inputDate shadow-none\"\n      [datepickerClass]=\"datepickerClass\"\n      [name]=\"formControlName\"\n      ngbDatepicker\n      #datePicker=\"ngbDatepicker\"\n      readonly\n      formControlName=\"date\"\n      [placeholder]=\"placeholder\"\n      (click)=\"datePicker.toggle()\"\n      [footerTemplate]=\"footerTemplate\"\n      (dateSelect)=\"onDateSelected()\"\n      [minDate]=\"minDate\"\n      [maxDate]=\"maxDate\"\n      (blur)=\"onBlur()\"\n      [displayMonths]=\"displayMonths\"\n      [firstDayOfWeek]=\"firstDayOfWeek\"\n      [markDisabled]=\"markDisabled\"\n      [navigation]=\"navigation\"\n      [outsideDays]=\"outsideDays\"\n      [autoClose]=\"autoClose\"\n      [dayTemplate]=\"dayTemplate\"\n      [dayTemplateData]=\"dayTemplateData\"\n      [restoreFocus]=\"restoreFocus\"\n      [weekdays]=\"weekdays\"\n      [attr.data-test]=\"'datepicker-' + data_test\"\n      >\n    <ng-template #footerTemplate>\n      <div *ngIf=\"this.datePickerForm.controls['date'].value && clearDateAllowed\">\n        <hr class=\"my-0\" />\n        <img\n          src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy4xMjEiIGhlaWdodD0iMTcuMTIxIiB2aWV3Qm94PSIwIDAgMTcuMTIxIDE3LjEyMSI+CjxnIGlkPSJLcnlkcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3OTAuNDM5IC0xMDA0LjQzOSkiPgo8bGluZSBpZD0iTGluZV80NiIgZGF0YS1uYW1lPSJMaW5lIDQ2IiB4Mj0iMTUiIHkyPSIxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDc5MS41IDEwMDUuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Y1MGEzNyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxsaW5lIGlkPSJMaW5lXzQ3IiBkYXRhLW5hbWU9IkxpbmUgNDciIHkxPSIxNSIgeDI9IjE1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NzkxLjUgMTAwNS41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZjUwYTM3IiBzdHJva2Utd2lkdGg9IjMiLz4KPC9nPgo8L3N2Zz4=\"\n          width=\"15%\"\n          (click)=\"clearSelectedDate(datePicker)\"\n          class=\"btn m-1 float-end\"\n          [ngbTooltip]=\"clearDateHoverText\"\n          />\n      </div>\n    </ng-template>\n  </div>\n</form>\n", styles: [".form-control[ngbdatepicker]{background-image:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 class%3D%22ionicon%22 viewBox%3D%220 0 512 512%22%3E%3Ctitle%3ECalendar Clear%3C%2Ftitle%3E%3Cpath d%3D%22M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4H36a4 4 0 00-4 4z%22%2F%3E%3C%2Fsvg%3E\");background-origin:content-box;background-repeat:no-repeat;background-position:right;background-size:22px;cursor:pointer}.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:.313rem;border-bottom-right-radius:.313rem}.form-control{border-radius:.313rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i1$4.FormBuilder }, { type: i2.TranslateService }]; }, propDecorators: { formControlName: [{
                type: Input
            }], body: [{
                type: Input
            }], datepickerClass: [{
                type: Input
            }], label: [{
                type: Input
            }], id: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], applyBorder: [{
                type: Input
            }], displayMonths: [{
                type: Input
            }], firstDayOfWeek: [{
                type: Input
            }], markDisabled: [{
                type: Input
            }], navigation: [{
                type: Input
            }], outsideDays: [{
                type: Input
            }], showWeekNumbers: [{
                type: Input
            }], startDate: [{
                type: Input
            }], autoClose: [{
                type: Input
            }], dayTemplate: [{
                type: Input
            }], dayTemplateData: [{
                type: Input
            }], placement: [{
                type: Input
            }], restoreFocus: [{
                type: Input
            }], weekdays: [{
                type: Input
            }], clearDateAllowed: [{
                type: Input
            }], clearDateHoverText: [{
                type: Input
            }], dataTestPrefix: [{
                type: Input
            }], dateSelect: [{
                type: Output
            }], reset: [{
                type: Output
            }] } });

class GlassPaneService {
    constructor() {
        this.glassPaneActive = new BehaviorSubject(false);
        this.idSet = new Set();
    }
    lockScreen() {
        const UUID = crypto.randomUUID();
        this.idSet.add(UUID);
        const unlock = () => {
            this.idSet.delete(UUID);
            if (this.idSet.size === 0) {
                this.removeGlassPane();
            }
        };
        if (!this.glassPaneActive.value) {
            this.createGlassPane();
        }
        return unlock;
    }
    unlockScreen() {
        this.idSet.clear();
        this.removeGlassPane();
    }
    subscribe(observer) {
        return this.glassPaneActive.subscribe(observer);
    }
    getBehaviorSubject() {
        return this.glassPaneActive;
    }
    createGlassPane() {
        this.glassPaneActive.next(true);
    }
    removeGlassPane() {
        this.glassPaneActive.next(false);
    }
}
GlassPaneService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GlassPaneService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return []; } });

class GlassPane {
    constructor(renderer, elementRef, glassPaneService) {
        this.useFullscreen = false;
        this.useService = false;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.glassPaneService = glassPaneService;
    }
    toggleGlasspane(displayGlassPane) {
        if (!this.useService) {
            if (displayGlassPane) {
                this.showGlasspane();
            }
            else {
                this.hideGlasspane();
            }
        }
        else {
            const htmlElement = this.elementRef.nativeElement;
            console.warn("Error in configuration of GlobalGlassPaneDirective on " + htmlElement.nodeName + ". Cannot use toggleGlasspane function with useService set.");
        }
    }
    showGlasspane() {
        if (!this.elementRef.nativeElement.contains(this.glassPaneElement)) {
            this.renderer.appendChild(this.elementRef.nativeElement, this.glassPaneElement);
        }
    }
    hideGlasspane() {
        if (this.elementRef.nativeElement.contains(this.glassPaneElement)) {
            this.renderer.removeChild(this.elementRef.nativeElement, this.glassPaneElement);
        }
    }
    ngOnInit() {
        this.testElementPosition();
        this.glassPaneElement = this.generateGlasspaneElement();
        this.renderer.setAttribute(this.elementRef.nativeElement, "scu-debug-show-pane", 'undefined');
        if (this.useService) {
            this.showGlasspaneSubscription = this.glassPaneService.subscribe({
                next: showPane => {
                    this.renderer.setAttribute(this.elementRef.nativeElement, "scu-debug-show-pane", showPane + '');
                    if (showPane) {
                        this.showGlasspane();
                    }
                    else {
                        this.hideGlasspane();
                    }
                }
            });
        }
    }
    generateGlasspaneElement() {
        const glassPaneDiv = this.renderer.createElement("div");
        this.renderer.addClass(glassPaneDiv, "glasspane");
        if (this.useFullscreen) {
            this.renderer.addClass(glassPaneDiv, "fullscreen");
        }
        const glassPaneSpinner = this.renderer.createElement("div");
        this.renderer.addClass(glassPaneSpinner, "spinner-border");
        this.renderer.addClass(glassPaneSpinner, "spinnercontent");
        this.renderer.appendChild(glassPaneDiv, glassPaneSpinner);
        return glassPaneDiv;
    }
    testElementPosition() {
        const htmlElement = this.elementRef.nativeElement;
        const elementStyle = window.getComputedStyle(htmlElement);
        if (!this.useFullscreen && elementStyle.getPropertyValue("position") === "static") {
            console.warn("GlobalGlassPaneDirective has been set on element " + htmlElement.nodeName + " but its positioning is set to static.\n" +
                "Static positioning does not work with overlapping elements, so the glasspane will not size to fill the target. Choose another position type," +
                " like relative or absolute, or set useFullscreen to true to let the glasspane fill the entire screen");
        }
    }
    ngOnDestroy() {
        if (this.showGlasspaneSubscription) {
            this.showGlasspaneSubscription.unsubscribe();
        }
    }
}
GlassPane.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPane, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: GlassPaneService }], target: i0.ɵɵFactoryTarget.Directive });
GlassPane.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: GlassPane, selector: "[scu-glasspane]", inputs: { useFullscreen: "useFullscreen", useService: "useService" }, exportAs: ["GlassPane"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPane, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scu-glasspane]',
                    exportAs: 'GlassPane'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: GlassPaneService }]; }, propDecorators: { useFullscreen: [{
                type: Input
            }], useService: [{
                type: Input
            }] } });

class GlasspaneTestComponent {
    constructor() {
    }
    toggleGpDiv1(displayGlassPane) {
        this.glassPanedDiv1.toggleGlasspane(displayGlassPane);
    }
    toggleGpDiv2(displayGlassPane) {
        this.glassPanedDiv2.toggleGlasspane(displayGlassPane);
    }
    toggleGpButton(displayGlassPane) {
        this.glassPanedButton.toggleGlasspane(displayGlassPane);
    }
}
GlasspaneTestComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlasspaneTestComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
GlasspaneTestComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: GlasspaneTestComponent, selector: "tst-glasspane", viewQueries: [{ propertyName: "glassPanedDiv1", first: true, predicate: ["gpdiv1"], descendants: true }, { propertyName: "glassPanedDiv2", first: true, predicate: ["gpdiv2"], descendants: true }, { propertyName: "glassPanedButton", first: true, predicate: ["gpbutton"], descendants: true }], ngImport: i0, template: "<div id=\"div1\" style=\"position: relative\" scu-glasspane #gpdiv1=\"GlassPane\" [useService]=\"true\">\n  <button id=\"button\" style=\"position: relative\" scu-glasspane #gpbutton=\"GlassPane\" ></button>\n</div>\n<div id=\"div2\" style=\"position: relative\" scu-glasspane #gpdiv2=\"GlassPane\" [useService]=\"true\">\n  <p>something something test test test</p>\n</div>\n\n", dependencies: [{ kind: "directive", type: GlassPane, selector: "[scu-glasspane]", inputs: ["useFullscreen", "useService"], exportAs: ["GlassPane"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlasspaneTestComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tst-glasspane', template: "<div id=\"div1\" style=\"position: relative\" scu-glasspane #gpdiv1=\"GlassPane\" [useService]=\"true\">\n  <button id=\"button\" style=\"position: relative\" scu-glasspane #gpbutton=\"GlassPane\" ></button>\n</div>\n<div id=\"div2\" style=\"position: relative\" scu-glasspane #gpdiv2=\"GlassPane\" [useService]=\"true\">\n  <p>something something test test test</p>\n</div>\n\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { glassPanedDiv1: [{
                type: ViewChild,
                args: ['gpdiv1']
            }], glassPanedDiv2: [{
                type: ViewChild,
                args: ['gpdiv2']
            }], glassPanedButton: [{
                type: ViewChild,
                args: ['gpbutton']
            }] } });

class GlassPaneInterceptor {
    constructor(glassPaneService, sosCommonUiConfig) {
        this.glassPaneService = glassPaneService;
        this.sosCommonUiConfig = sosCommonUiConfig;
    }
    intercept(req, next) {
        let gracePeriod = 300;
        let cancelFunction;
        let gracePeriodTimeout;
        if (this.sosCommonUiConfig.enableGlassPaneOnHTTP) {
            const config = this.sosCommonUiConfig.enableGlassPaneOnHTTP;
            let include = false;
            if (this.isBlackAndWhitelist(config)) {
                if (config.gracePeriod) {
                    gracePeriod = config.gracePeriod;
                }
                const requestPath = req.url;
                if (config.whiteList) {
                    for (const whitelistURL in config.whiteList) {
                        if (requestPath.match(whitelistURL)) {
                            include = true;
                            break;
                        }
                    }
                }
                else {
                    include = true;
                }
                if (config.blackList) {
                    for (const blacklistURL in config.blackList) {
                        if (requestPath.match(blacklistURL)) {
                            include = false;
                            break;
                        }
                    }
                }
            }
            else {
                include = true;
            }
            if (include) {
                gracePeriodTimeout = setTimeout(() => {
                    cancelFunction = this.glassPaneService.lockScreen();
                }, gracePeriod);
            }
        }
        return next.handle(req).pipe(tap(event => {
            if (event instanceof HttpResponse) {
                clearTimeout(gracePeriodTimeout);
                if (cancelFunction) {
                    cancelFunction();
                }
            }
        }), catchError((error) => {
            // we expect 404, it's not a failure for us.
            clearTimeout(gracePeriodTimeout);
            if (cancelFunction) {
                cancelFunction();
            }
            return throwError(error);
        }));
    }
    isBlackAndWhitelist(object) {
        return 'backList' in object && 'whiteList' in object;
    }
}
GlassPaneInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneInterceptor, deps: [{ token: GlassPaneService }, { token: SOSCommonUIConfig }], target: i0.ɵɵFactoryTarget.Injectable });
GlassPaneInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneInterceptor, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: GlassPaneInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: GlassPaneService }, { type: SOSCommonUIConfig }]; } });

var ModalOptionEnum;
(function (ModalOptionEnum) {
    ModalOptionEnum["APPROVE"] = "approve";
    ModalOptionEnum["CANCEL"] = "cancel";
})(ModalOptionEnum || (ModalOptionEnum = {}));

/**
 * @deprecated
 * brug modal-info-panel i stedet.
 */
class ModalPopUpComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    clickApprove() {
        this.activeModal.close(ModalOptionEnum.APPROVE);
    }
    clickCancel() {
        this.activeModal.close(ModalOptionEnum.CANCEL);
    }
}
ModalPopUpComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalPopUpComponent, deps: [{ token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
ModalPopUpComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ModalPopUpComponent, selector: "scu-modal-pop-up", inputs: { headerText: "headerText", mainContent: "mainContent", approve: "approve", cancel: "cancel" }, ngImport: i0, template: "<div class=\"sos-style\">\n  <div class=\"modal-header border-bottom-0 pb-2\">\n  </div>\n  <h2 class=\"text-center m-0\">\n    {{ headerText }}\n  </h2>\n  <div class=\"modal-body text-16 d-flex flex-column pt-0 pb-2\">\n    <p class=\"m-2\"> {{ mainContent }} </p>\n    <button\n      id=\"next\"\n      class=\"btn text-16 filled-button my-3 py-2 mx-1\"\n      (click)=\"clickApprove()\">{{ approve }}\n    </button>\n    <button\n      id=\"back\"\n      class=\"btn my-2 text-decoration-underline\"\n      (click)=\"clickCancel()\">{{ cancel }}\n    </button>\n  </div>\n</div>\n\n", styles: [".modal-body{display:flex}h2{font-size:20px}button{font-size:16px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalPopUpComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-modal-pop-up', template: "<div class=\"sos-style\">\n  <div class=\"modal-header border-bottom-0 pb-2\">\n  </div>\n  <h2 class=\"text-center m-0\">\n    {{ headerText }}\n  </h2>\n  <div class=\"modal-body text-16 d-flex flex-column pt-0 pb-2\">\n    <p class=\"m-2\"> {{ mainContent }} </p>\n    <button\n      id=\"next\"\n      class=\"btn text-16 filled-button my-3 py-2 mx-1\"\n      (click)=\"clickApprove()\">{{ approve }}\n    </button>\n    <button\n      id=\"back\"\n      class=\"btn my-2 text-decoration-underline\"\n      (click)=\"clickCancel()\">{{ cancel }}\n    </button>\n  </div>\n</div>\n\n", styles: [".modal-body{display:flex}h2{font-size:20px}button{font-size:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }]; }, propDecorators: { headerText: [{
                type: Input
            }], mainContent: [{
                type: Input
            }], approve: [{
                type: Input
            }], cancel: [{
                type: Input
            }] } });

class BlocklistComponent {
    constructor() {
        /**
         * If value is set to 0 there is no restriction on number of selected items
         */
        this.maxPossibleToSelectItems = Number.MAX_SAFE_INTEGER;
        this.placeholderWhenEmpty = 'Select Items';
        this.placeholder = 'Select More Items';
        this.selectedItems = new Set();
        this.searchableItems = [];
        this.touched = false;
        this._items = [];
        this.onChange = (_) => { };
        this.onTouched = () => { };
    }
    validate(control) {
        if (this.customValidator) {
            return this.customValidator(control);
        }
        return this.defaultValidator(control);
    }
    defaultValidator(control) {
        const items = control.value;
        if (items?.length === 0) {
            return { mustNotBeEmpty: true };
        }
        return null;
    }
    set items(newItems) {
        const newSelectedItems = new Set();
        for (const item of newItems) {
            if (this.selectedItems.has(item)) {
                newSelectedItems.add(item);
            }
        }
        this.selectedItems = newSelectedItems;
        this._items = newItems;
        this.searchableItems = this.getSearchableList();
    }
    setOpen(open) {
        if (open) {
            this.ngSelectComponent.open();
        }
        else {
            this.ngSelectComponent.close();
        }
    }
    selectItem(newItem) {
        if (newItem != null) {
            this.markAsTouched();
            this.selectedItems.add(newItem);
            this.searchableItems = this.getSearchableList();
            this.ngSelectComponent.clearModel();
            this.ngSelectComponent.blur();
            this.onChange(this.getSelectedList());
        }
    }
    removeSelected(item) {
        this.markAsTouched();
        this.selectedItems.delete(item);
        this.searchableItems = this.getSearchableList();
        this.onChange(this.getSelectedList());
    }
    showSearchBar() {
        return this.getSearchableList().length > 0 && this.selectedItems?.size < this.maxPossibleToSelectItems;
    }
    getPlaceholder() {
        if (this.selectedItems.size > 0) {
            return this.placeholder ? this.placeholder : this.placeholderWhenEmpty;
        }
        else {
            return this.placeholderWhenEmpty;
        }
    }
    getSearchableList() {
        return this._items.filter(item => (!this.selectedItems.has(item)));
    }
    getSelectedList() {
        return this._items.filter(value => this.selectedItems.has(value));
    }
    /* ControlValueAccessor */
    writeValue(selectListItems) {
        const newSelectedItems = new Set();
        selectListItems.forEach(selectedItem => { newSelectedItems.add(selectedItem); });
        this.selectedItems = newSelectedItems;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    markAsTouched() {
        if (this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
}
BlocklistComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BlocklistComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BlocklistComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BlocklistComponent, selector: "scu-blocklist", inputs: { customValidator: "customValidator", maxPossibleToSelectItems: "maxPossibleToSelectItems", placeholderWhenEmpty: "placeholderWhenEmpty", placeholder: "placeholder", items: "items" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BlocklistComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BlocklistComponent),
            multi: true
        }
    ], viewQueries: [{ propertyName: "ngSelectComponent", first: true, predicate: NgSelectComponent, descendants: true }], ngImport: i0, template: "<div>\n  <ul class=\"list-group mb-2\" *ngIf=\"selectedItems.size > 0\">\n    <li class=\"list-group-item mt-2 d-flex justify-content-between align-items-center p-0 ps-4\"\n        *ngFor=\"let item of selectedItems\">\n      {{ item.name }}\n      <span>\n      <button type=\"button\" class=\"close btn shadow-none p-0 scu-primary-icon-hover\" aria-label=\"Close\" (click)=\"removeSelected(item)\">\n        <svg viewBox=\"0 0 50 50\" width=\"50\" height=\"50\">\n          <svg class=\"scu-primary-icon-hover\" renderedicon=\"cross_with_hover\"></svg>\n      </svg>\n        <!--        <i class=\"fas fa-xmark fs-3\">&times;</i>-->\n      </button>\n      </span>\n    </li>\n  </ul>\n\n  <div>\n    <ng-select *ngIf=\"showSearchBar()\"\n               [items]=\"searchableItems\"\n               [placeholder]=\"getPlaceholder()\"\n               bindLabel=\"name\"\n               (change)=\"selectItem($event)\"\n               class=\"hide-arrow\"\n    >  </ng-select>\n\n\n  </div>\n\n\n\n</div>\n", styles: [".pointer{cursor:pointer}.close.btn:hover{border-color:transparent}.list-group-item{border-radius:6px}.list-group-item+.list-group-item{border-top-width:1px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: SvgIconRendererDirective, selector: "svg[renderedicon]", inputs: ["source", "renderedicon"], exportAs: ["SvgIconRenderer"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BlocklistComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-blocklist', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => BlocklistComponent),
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => BlocklistComponent),
                            multi: true
                        }
                    ], template: "<div>\n  <ul class=\"list-group mb-2\" *ngIf=\"selectedItems.size > 0\">\n    <li class=\"list-group-item mt-2 d-flex justify-content-between align-items-center p-0 ps-4\"\n        *ngFor=\"let item of selectedItems\">\n      {{ item.name }}\n      <span>\n      <button type=\"button\" class=\"close btn shadow-none p-0 scu-primary-icon-hover\" aria-label=\"Close\" (click)=\"removeSelected(item)\">\n        <svg viewBox=\"0 0 50 50\" width=\"50\" height=\"50\">\n          <svg class=\"scu-primary-icon-hover\" renderedicon=\"cross_with_hover\"></svg>\n      </svg>\n        <!--        <i class=\"fas fa-xmark fs-3\">&times;</i>-->\n      </button>\n      </span>\n    </li>\n  </ul>\n\n  <div>\n    <ng-select *ngIf=\"showSearchBar()\"\n               [items]=\"searchableItems\"\n               [placeholder]=\"getPlaceholder()\"\n               bindLabel=\"name\"\n               (change)=\"selectItem($event)\"\n               class=\"hide-arrow\"\n    >  </ng-select>\n\n\n  </div>\n\n\n\n</div>\n", styles: [".pointer{cursor:pointer}.close.btn:hover{border-color:transparent}.list-group-item{border-radius:6px}.list-group-item+.list-group-item{border-top-width:1px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { ngSelectComponent: [{
                type: ViewChild,
                args: [NgSelectComponent]
            }], customValidator: [{
                type: Input
            }], 
        /**
         * If value is set to 0 there is no restriction on number of selected items
         */
        maxPossibleToSelectItems: [{
                type: Input
            }], placeholderWhenEmpty: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

class BaseBindingComponent {
    set disabled(value) {
        this._disabled = (value === '' || value === 'true' || value === true) ? true : false;
    }
    get disabled() {
        return this._disabled;
    }
}
BaseBindingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseBindingComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BaseBindingComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: BaseBindingComponent, inputs: { disabled: "disabled" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BaseBindingComponent, decorators: [{
            type: Directive
        }], propDecorators: { disabled: [{
                type: Input
            }] } });

class RadioGroupComponent extends BaseBindingComponent {
    constructor(control) {
        super();
        this.control = control;
        this.group = this.formControlName;
        this.labelClasses = 'ms-1';
        this.radioButtonClasses = '';
        this.wrapperClasses = '';
        this.isDisabledSetOnFormControl = false;
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabledSetOnFormControl = isDisabled;
    }
    isDisabled(button) {
        return (button.hasOwnProperty('disabled')) ? button.disabled : this.isDisabledSetOnFormControl;
    }
    onSelect(value) {
        this.onChange(value);
    }
}
RadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadioGroupComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
RadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: RadioGroupComponent, selector: "scu-radio-group", inputs: { formControlName: "formControlName", group: "group", labelClasses: "labelClasses", radioButtonClasses: "radioButtonClasses", wrapperClasses: "wrapperClasses", buttons: "buttons" }, usesInheritance: true, ngImport: i0, template: "<div *ngFor=\"let button of buttons\" class=\"form-check mb-0 ps-0\" [ngClass]=\"wrapperClasses\" >\n    <input\n      type=\"radio\" \n      class=\"form-check-input\"\n      [ngClass]=\"radioButtonClasses\"\n      [disabled]=\"isDisabled(button)\" \n      [name]=\"group\"\n      [value]=\"button.value\"\n      [id]=\"button.value\" \n      (change)=\"onSelect(button.value)\"\n      [checked]=\"button.value === value\"\n      [attr.data-test]=\"'radio-group' + '-' + group + '-' + value \"\n    >\n    <label [ngClass]=\"labelClasses\" class=\"form-check-label\" [for]=\"button.value\">\n        {{button.label}}\n    </label>\n</div>\n  ", styles: [".form-check-input{margin:.75rem}.form-check-label{margin-top:.75rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-radio-group', template: "<div *ngFor=\"let button of buttons\" class=\"form-check mb-0 ps-0\" [ngClass]=\"wrapperClasses\" >\n    <input\n      type=\"radio\" \n      class=\"form-check-input\"\n      [ngClass]=\"radioButtonClasses\"\n      [disabled]=\"isDisabled(button)\" \n      [name]=\"group\"\n      [value]=\"button.value\"\n      [id]=\"button.value\" \n      (change)=\"onSelect(button.value)\"\n      [checked]=\"button.value === value\"\n      [attr.data-test]=\"'radio-group' + '-' + group + '-' + value \"\n    >\n    <label [ngClass]=\"labelClasses\" class=\"form-check-label\" [for]=\"button.value\">\n        {{button.label}}\n    </label>\n</div>\n  ", styles: [".form-check-input{margin:.75rem}.form-check-label{margin-top:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; }, propDecorators: { formControlName: [{
                type: Input
            }], group: [{
                type: Input
            }], labelClasses: [{
                type: Input
            }], radioButtonClasses: [{
                type: Input
            }], wrapperClasses: [{
                type: Input
            }], buttons: [{
                type: Input
            }] } });

class ModalInfoPanelComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() {
    }
    clickApprove() {
        this.activeModal.close(ModalOptionEnum.APPROVE);
    }
    clickCancel() {
        this.activeModal.close(ModalOptionEnum.CANCEL);
    }
}
ModalInfoPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalInfoPanelComponent, deps: [{ token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
ModalInfoPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ModalInfoPanelComponent, selector: "scu-modal-info-panel", inputs: { parentSelector: "parentSelector", headerText: "headerText", footerText: "footerText", mainContent: "mainContent", approve: "approve", cancel: "cancel" }, ngImport: i0, template: "\n<div class=\"sos-style\">\n    <div class=\"modal-header border-0\">\n        <h4 class=\"modal-title\" [innerHTML]=\"headerText\"></h4>\n        <svg class=\"close-icon align-self-start scu-secondary-dark-icon scu-secondary-dark-icon-hover scu-secondary-light-background-hover\"\n        renderedicon=\"cross_with_hover\" (click)=\"clickCancel()\" [attr.data-test]=\"'help-modal-close-'\"></svg>\n    </div>\n    <div class=\"modal-body text-16 d-flex flex-column pt-4 pb-4\" >\n      <span  [innerHTML]=\"mainContent\"></span>\n      <button *ngIf=\"approve\"\n        id=\"next\"\n        class=\"btn text-16 filled-button my-3 py-2 mx-1\"\n        (click)=\"clickApprove()\">{{ approve }}\n      </button>\n      <button *ngIf=\"cancel\"\n        id=\"back\"\n        class=\"btn my-2 text-decoration-underline\"\n        (click)=\"clickCancel()\">{{ cancel }}\n      </button>\n    </div>\n    <div class=\"modal-footer border-0\">\n        <p [attr.help-id]=\"'footer'\" [innerHTML]=\"footerText\"></p>\n    </div>\n    \n  </div>", styles: [".close-icon{width:2.5rem;height:2.5rem;flex-shrink:0;flex-grow:0;cursor:pointer}.modal-title{padding-top:1.25rem;font-size:calc(1.275rem + .3vw)}.modal-header{padding-left:2.25rem;padding-bottom:1rem}.modal-body{padding-left:2.25rem;padding-right:2.25rem;margin:0}.modal-footer{padding-left:2.25rem;padding-right:2.25rem;padding-bottom:2rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: SvgIconRendererDirective, selector: "svg[renderedicon]", inputs: ["source", "renderedicon"], exportAs: ["SvgIconRenderer"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalInfoPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scu-modal-info-panel', template: "\n<div class=\"sos-style\">\n    <div class=\"modal-header border-0\">\n        <h4 class=\"modal-title\" [innerHTML]=\"headerText\"></h4>\n        <svg class=\"close-icon align-self-start scu-secondary-dark-icon scu-secondary-dark-icon-hover scu-secondary-light-background-hover\"\n        renderedicon=\"cross_with_hover\" (click)=\"clickCancel()\" [attr.data-test]=\"'help-modal-close-'\"></svg>\n    </div>\n    <div class=\"modal-body text-16 d-flex flex-column pt-4 pb-4\" >\n      <span  [innerHTML]=\"mainContent\"></span>\n      <button *ngIf=\"approve\"\n        id=\"next\"\n        class=\"btn text-16 filled-button my-3 py-2 mx-1\"\n        (click)=\"clickApprove()\">{{ approve }}\n      </button>\n      <button *ngIf=\"cancel\"\n        id=\"back\"\n        class=\"btn my-2 text-decoration-underline\"\n        (click)=\"clickCancel()\">{{ cancel }}\n      </button>\n    </div>\n    <div class=\"modal-footer border-0\">\n        <p [attr.help-id]=\"'footer'\" [innerHTML]=\"footerText\"></p>\n    </div>\n    \n  </div>", styles: [".close-icon{width:2.5rem;height:2.5rem;flex-shrink:0;flex-grow:0;cursor:pointer}.modal-title{padding-top:1.25rem;font-size:calc(1.275rem + .3vw)}.modal-header{padding-left:2.25rem;padding-bottom:1rem}.modal-body{padding-left:2.25rem;padding-right:2.25rem;margin:0}.modal-footer{padding-left:2.25rem;padding-right:2.25rem;padding-bottom:2rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }]; }, propDecorators: { parentSelector: [{
                type: Input
            }], headerText: [{
                type: Input
            }], footerText: [{
                type: Input
            }], mainContent: [{
                type: Input
            }], approve: [{
                type: Input
            }], cancel: [{
                type: Input
            }] } });

function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
class SosCommonUiModule {
    static forRoot(sosCommonUIParams) {
        return {
            ngModule: SosCommonUiModule,
            providers: [
                {
                    provide: SOSCommonUIConfig,
                    useValue: sosCommonUIParams
                }
            ]
        };
    }
}
SosCommonUiModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SosCommonUiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SosCommonUiModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SosCommonUiModule, declarations: [NextButtonComponent,
        PreviousButtonComponent,
        ProgressBarComponent,
        SosLogoComponent,
        FooterComponent,
        BurgerMenuComponent,
        SosLogoComponent,
        TitleHeaderComponent,
        HeaderComponent,
        TestDataPipe,
        RadioGroupComponent,
        ExtendableRadioListComponent,
        RadioButtonListComponent,
        TextAreaComponent,
        DatepickerListComponent,
        ExtendableRadioListComponent,
        InputFieldPlaceholderMaskComponent,
        PhoneNumberComponent,
        SelectFlagComponent,
        SimpleFooterComponent,
        ButtonComponent,
        CheckboxLabelListComponent,
        DatePickerComponent,
        GlassPane,
        SvgIconRendererDirective,
        GlasspaneTestComponent,
        CheckboxLabelListComponent,
        ModalPopUpComponent,
        BlocklistComponent,
        ModalInfoPanelComponent], imports: [BrowserModule,
        NgSelectModule,
        NgbModule,
        HttpClientModule, i2.TranslateModule, RouterModule,
        ReactiveFormsModule,
        FormsModule, i2$1.NgxMaskModule], exports: [NextButtonComponent,
        PreviousButtonComponent,
        ProgressBarComponent,
        SosLogoComponent,
        TitleHeaderComponent,
        SosLogoComponent,
        RadioGroupComponent,
        FooterComponent,
        BurgerMenuComponent,
        HeaderComponent,
        TestDataPipe,
        ExtendableRadioListComponent,
        RadioButtonListComponent,
        TextAreaComponent,
        DatepickerListComponent,
        TextAreaComponent,
        ExtendableRadioListComponent,
        InputFieldPlaceholderMaskComponent,
        PhoneNumberComponent,
        SelectFlagComponent,
        SimpleFooterComponent,
        ButtonComponent,
        CheckboxLabelListComponent,
        DatePickerComponent,
        GlassPane,
        SvgIconRendererDirective,
        CheckboxLabelListComponent,
        ModalPopUpComponent,
        BlocklistComponent,
        ModalInfoPanelComponent] });
SosCommonUiModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SosCommonUiModule, providers: [
        TranslatePipe,
        MaskApplierService,
        NgxMaskModule,
        DocumentService,
        CssService,
        BrandingService,
        {
            provide: APP_INITIALIZER,
            useFactory: cssServiceFactory,
            deps: [CssService, BrandingService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlassPaneInterceptor,
            deps: [GlassPaneService, SOSCommonUIConfig],
            multi: true
        },
        {
            provide: NEW_CONFIG,
            useFactory: ngxMaskConfigFactory,
            deps: [SOSCommonUIConfig]
        }
    ], imports: [BrowserModule,
        NgSelectModule,
        NgbModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgxMaskModule.forRoot()] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SosCommonUiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NextButtonComponent,
                        PreviousButtonComponent,
                        ProgressBarComponent,
                        SosLogoComponent,
                        FooterComponent,
                        BurgerMenuComponent,
                        SosLogoComponent,
                        TitleHeaderComponent,
                        HeaderComponent,
                        TestDataPipe,
                        RadioGroupComponent,
                        ExtendableRadioListComponent,
                        RadioButtonListComponent,
                        TextAreaComponent,
                        DatepickerListComponent,
                        ExtendableRadioListComponent,
                        InputFieldPlaceholderMaskComponent,
                        PhoneNumberComponent,
                        SelectFlagComponent,
                        SimpleFooterComponent,
                        ButtonComponent,
                        CheckboxLabelListComponent,
                        DatePickerComponent,
                        GlassPane,
                        SvgIconRendererDirective,
                        GlasspaneTestComponent,
                        CheckboxLabelListComponent,
                        ModalPopUpComponent,
                        BlocklistComponent,
                        ModalInfoPanelComponent
                    ],
                    imports: [
                        BrowserModule,
                        NgSelectModule,
                        NgbModule,
                        HttpClientModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: HttpLoaderFactory,
                                deps: [HttpClient]
                            }
                        }),
                        RouterModule,
                        ReactiveFormsModule,
                        FormsModule,
                        NgxMaskModule.forRoot()
                    ],
                    providers: [
                        TranslatePipe,
                        MaskApplierService,
                        NgxMaskModule,
                        DocumentService,
                        CssService,
                        BrandingService,
                        {
                            provide: APP_INITIALIZER,
                            useFactory: cssServiceFactory,
                            deps: [CssService, BrandingService],
                            multi: true
                        },
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: GlassPaneInterceptor,
                            deps: [GlassPaneService, SOSCommonUIConfig],
                            multi: true
                        },
                        {
                            provide: NEW_CONFIG,
                            useFactory: ngxMaskConfigFactory,
                            deps: [SOSCommonUIConfig]
                        }
                    ],
                    exports: [
                        NextButtonComponent,
                        PreviousButtonComponent,
                        ProgressBarComponent,
                        SosLogoComponent,
                        TitleHeaderComponent,
                        SosLogoComponent,
                        RadioGroupComponent,
                        FooterComponent,
                        BurgerMenuComponent,
                        HeaderComponent,
                        TestDataPipe,
                        ExtendableRadioListComponent,
                        RadioButtonListComponent,
                        TextAreaComponent,
                        DatepickerListComponent,
                        TextAreaComponent,
                        ExtendableRadioListComponent,
                        InputFieldPlaceholderMaskComponent,
                        PhoneNumberComponent,
                        SelectFlagComponent,
                        SimpleFooterComponent,
                        ButtonComponent,
                        CheckboxLabelListComponent,
                        DatePickerComponent,
                        GlassPane,
                        SvgIconRendererDirective,
                        CheckboxLabelListComponent,
                        ModalPopUpComponent,
                        BlocklistComponent,
                        ModalInfoPanelComponent
                    ]
                }]
        }] });
function cssServiceFactory(cssService, brandingService) {
    return () => {
        return new Promise((resolve) => {
            return brandingService.getBrandingColors().then(() => {
                cssService.resetToDefaultColors();
                resolve();
            });
        });
    };
}
function ngxMaskConfigFactory(sosConfig) {
    const newOptions = sosConfig.maskOptions ? sosConfig.maskOptions : {};
    newOptions.patterns = { ...initialConfig.patterns, ...{
            [1]: { pattern: new RegExp('[1-9]') }
        }
    };
    return newOptions;
}

class Graph {
    constructor(vertices = []) {
        this.vertices = vertices;
    }
    addNode(vertex) {
        if (!this.vertices.includes(vertex)) {
            this.vertices.push(vertex);
        }
    }
    /**
     * traverse from getNextNode method
     * */
    traverse(fromVertex, vertices = [], provider) {
        vertices.push(fromVertex);
        const nextVertex = fromVertex.getNextNode(provider);
        if (nextVertex === undefined || this.isGreaterThanVerticesArr(vertices)) {
            return vertices;
        }
        return this.traverse(nextVertex, vertices, provider);
    }
    isGreaterThanVerticesArr(arr) {
        return arr.length > this.vertices.length;
    }
}

class ConfigWrapperRouteNode {
}

class NavigationService {
    constructor(configWrapperRouteNode, router) {
        this.configWrapperRouteNode = configWrapperRouteNode;
        this.router = router;
        this.navigationMap = new Map();
        this.history = [];
        this.initCreateNavigationMap(configWrapperRouteNode.routes);
        this.graph = new Graph(configWrapperRouteNode.routes);
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            let currentUrl;
            if (configWrapperRouteNode.getPageFromUr !== undefined) {
                currentUrl = configWrapperRouteNode.getPageFromUr(event);
            }
            else {
                currentUrl = this.getPageFromUrlDefault(event);
            }
            this.currentPage = this.findRouteNodeByRoutePath(currentUrl);
            this.history.push(this.currentPage);
        });
    }
    getPageFromUrlDefault(event) {
        return event.url.startsWith("/") ? event.url.slice(1) : event.url;
    }
    initCreateNavigationMap(routes) {
        routes.forEach(p => this.navigationMap.set(p.value.path, p));
    }
    findRouteNodeByRoutePath(routePath) {
        return this.configWrapperRouteNode.routes.find(p => p.value.path === routePath);
    }
    getNextPage() {
        return this.navigationMap.get(this.currentPage.value.path).getNextNode;
    }
    getNextPageFromRoutePath(routePath) {
        const routeNode = this.findRouteNodeByRoutePath(routePath);
        return this.navigationMap.get(routeNode.value.path).getNextNode;
    }
    getPreviousPage() {
        return this.navigationMap.get(this.currentPage.value.path).getPreviousNode;
    }
    getPreviousPageFromRoutePath(routePath) {
        const routeNode = this.findRouteNodeByRoutePath(routePath);
        return this.navigationMap.get(routeNode.value.path).getPreviousNode;
    }
    traverseGraph(provider = undefined, fromVertex = this.currentPage) {
        return fromVertex ? this.graph.traverse(fromVertex, [], provider) : [];
    }
    /**
     * Calculate logic for Progress bar
     * */
    updateDepthOnVertices(provider = undefined, startPath, dataAttr = 'depth') {
        const startVertex = this.findRouteNodeByRoutePath(startPath);
        if (startVertex) {
            const vertices = this.graph.traverse(startVertex, [], provider);
            const verticesArrSize = vertices.length;
            const percentage = 100 / verticesArrSize;
            let depth = percentage;
            vertices.forEach((vertex, index) => {
                const counter = index + 1;
                if (vertex?.value?.data) {
                    depth = Math.round((percentage * counter));
                    vertex.value.data[dataAttr] = depth;
                }
            });
        }
    }
    getVertexOnRoutePath(routePath) {
        const routeNode = this.findRouteNodeByRoutePath(routePath);
        return this.navigationMap.get(routeNode.value.path);
    }
    /**
     * The routePath is used as a key the navigationMap for the Vertex
     */
    setGetNextNodeMethod(routePath, getNextNodeMethod) {
        let vertex = this.navigationMap.get(routePath);
        if (vertex) {
            vertex.getNextNode = getNextNodeMethod;
            this.navigationMap.set(routePath, vertex);
        }
    }
    /**
     * The routePath is used as a key the navigationMap for the Vertex
     */
    setGetPreviousNode(routePath, getPreviousNode) {
        let vertex = this.navigationMap.get(routePath);
        if (vertex) {
            vertex.getPreviousNode = getPreviousNode;
            this.navigationMap.set(routePath, vertex);
        }
    }
    getHistoryOfVisitedVertices() {
        return this.history;
    }
    getLastVisitedVertex() {
        return this.history[this.history.length - 1];
    }
}
NavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationService, deps: [{ token: 'configWrapperRouteNode' }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
NavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: ConfigWrapperRouteNode, decorators: [{
                    type: Inject,
                    args: ['configWrapperRouteNode']
                }] }, { type: i1$1.Router }]; } });

class NavigationModule {
    static forChild(configWrapperRouteNode) {
        const routes = NavigationModule.toRoutes(configWrapperRouteNode.routes, configWrapperRouteNode.defaultRoutes || []);
        return {
            ngModule: NavigationModule,
            providers: [
                { provide: ROUTES, useValue: routes, multi: true },
                { provide: PreloadingStrategy, useClass: NoPreloading },
                { provide: 'configWrapperRouteNode', useFactory: () => configWrapperRouteNode }
            ]
        };
    }
    static toRoutes(routes, defaultRoutes) {
        const resultRoutes = routes.map(p => p.value);
        resultRoutes.push(...defaultRoutes);
        return resultRoutes;
    }
}
NavigationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavigationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: NavigationModule, imports: [CommonModule, RouterModule], exports: [RouterModule] });
NavigationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationModule, providers: [
        NavigationService
    ], imports: [CommonModule, RouterModule, RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule],
                    providers: [
                        NavigationService
                    ],
                    exports: [RouterModule]
                }]
        }] });

class EnvService {
    constructor(baseConfig) {
        this.config = baseConfig;
    }
    setValue(key, value) {
        this.config[key] = value;
    }
    getValue(key) {
        return this.config[key];
    }
}

class EnvServiceModule {
    static forRoot(configuration) {
        const envService = buildEnvServiceFactory(configuration);
        return {
            ngModule: EnvServiceModule,
            providers: [
                {
                    provide: EnvService,
                    useValue: envService
                }
            ]
        };
    }
}
EnvServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EnvServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EnvServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: EnvServiceModule });
EnvServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EnvServiceModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EnvServiceModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });
function buildEnvServiceFactory(baseConfig) {
    // Create env
    const env = new EnvService(baseConfig);
    // Read environment variables from browser window
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__env'] || {};
    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    for (const key in baseConfig) {
        if (browserWindowEnv.hasOwnProperty(key)) {
            const envOverride = browserWindowEnv[key];
            env.setValue(key, envOverride);
        }
    }
    for (const key in browserWindowEnv) {
        if (!baseConfig[key]) {
            throw new Error("Found unmatched configuration key " + key + " in configuration. This will be ignored as it is not defined in the " +
                "application configuration");
        }
    }
    return env;
}

function phoneValidator() {
    return (control) => {
        const phone = control.value;
        const hasError = !phone.prefix || !phone.number;
        return hasError ? { phone: true } : null;
    };
}

class ModalsService {
    constructor(modalService, translateService) {
        this.modalService = modalService;
        this.translateService = translateService;
    }
    /**
     * Opens ModalInfoPanelComponent dialog with
     * @param attributes
     * @param options
     */
    openDialog(attributes, options) {
        const modalRef = this.modalService.open(ModalInfoPanelComponent, options);
        for (const key in attributes) {
            if (attributes[key]) {
                modalRef.componentInstance[key] = attributes[key];
            }
        }
    }
    openHelpNeeded(selector) {
        const config = { size: 'lg' };
        const attributes = {
            headerText: this.translateService.instant(`help.${selector}.header`),
            mainContent: this.translateService.instant(`help.${selector}.body`),
            footerText: this.translateService.instant('help.footer')
        };
        this.openDialog(attributes, config);
    }
}
ModalsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalsService, deps: [{ token: i1$2.NgbModal }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
ModalsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ModalsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: i2.TranslateService }]; } });

/*
 * Public API Surface of sos-common-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BlocklistComponent, BrandingService, BurgerMenuComponent, ButtonComponent, CheckboxLabelListComponent, ConfigWrapperRouteNode, CountryEnum, CssService, CustomDateParserFormatter, DatePickerComponent, DatepickerLanguage, DatepickerListComponent, DocumentService, EnvService, EnvServiceModule, ExtendableRadioListComponent, FooterComponent, FooterService, GlassPane, GlassPaneService, Graph, HeaderComponent, HttpLoaderFactory, InputFieldPlaceholderMaskComponent, LanguageEnum, LanguageService, ModalInfoPanelComponent, ModalOptionEnum, ModalPopUpComponent, ModalsService, Nationality, NavigationModule, NavigationService, NextButtonComponent, PhoneNumberComponent, PreviousButtonComponent, ProgressBarComponent, RadioButtonListComponent, RadioGroupComponent, RouterEventsService, SCUColor, SelectFlagComponent, SimpleFooterComponent, SosCommonUiModule, SosLogoComponent, SvgIconRendererDirective, SvgIconService, TestDataPipe, TextAreaComponent, TitleHeaderComponent, buildEnvServiceFactory, cssServiceFactory, customPatterns, filterLanguageToNordic, generateID, getBrowserLanguage, isAllUppercase, ngxMaskConfigFactory, parseJwt, phoneValidator, validateLanguage };
